<template>
  <svg
    v-if="name === 'book'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      d="M6 4H5a1 1 0 1 1 0-2h11V1a1 1 0 0 0-1-1H4a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V5a1 1 0 0 0-1-1h-7v8l-2-2-2 2V4z"
    />
  </svg>

  <svg
    v-else-if="name === 'side'"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M17 8H7c-2.21 0-4 1.79-4 4s1.79 4 4 4h10c2.21 0 4-1.79 4-4s-1.79-4-4-4zM7 15c-1.66 0-3-1.34-3-3s1.34-3 3-3s3 1.34 3 3s-1.34 3-3 3z"
      opacity=".3"
    />
    <path
      fill="currentColor"
      d="M17 6H7c-3.31 0-6 2.69-6 6s2.69 6 6 6h10c3.31 0 6-2.69 6-6s-2.69-6-6-6zm0 10H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h10c2.21 0 4 1.79 4 4s-1.79 4-4 4zM7 9c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3z"
    />
  </svg>

  <svg
    v-else-if="name === 'cash-wallets'"
    width="32"
    height="32"
    viewBox="0 0 24 24"
  >
    <path
      d="M5.5 0h13A5.5 5.5 0 0 1 24 5.5v13a5.5 5.5 0 0 1-5.5 5.5h-13A5.5 5.5 0 0 1 0 18.5v-13A5.5 5.5 0 0 1 5.5 0m9.89 15.18c0 1.58-.89 2.63-2.54 2.77v-5.34c1.7.52 2.54 1.05 2.54 2.57M11.65 6v4.88c-1.31-.38-2.62-.95-2.62-2.45c0-1.49 1.15-2.31 2.62-2.43m3.85 1.6l1-.8c-.88-1.14-2.1-1.88-3.65-2.03V3.8h-1.2v.95C9.5 4.89 7.68 6.17 7.68 8.5c0 2.5 2.06 3.28 3.97 3.79v5.67c-1.11-.12-2.36-.65-3.22-1.93l-1.13.75c.9 1.34 2.46 2.22 4.35 2.36v1.06h1.2v-1.04c2.5-.16 3.85-1.82 3.85-4.02c0-2.56-1.89-3.38-3.85-3.95V6.05c1.15.17 2 .71 2.65 1.55z"
      fill="currentColor"
    />
  </svg>

  <svg
    v-else-if="name === 'promotion-wallets'"
    width="32"
    height="32"
    viewBox="0 0 14 14"
  >
    <g
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path
        d="M5.02 3.485h-3.5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-4m-11-2.5h6.5"
      />
      <path
        d="m3.02 10.985l1.5-1.5l-1.5-1.5m3 3h1.5m-.124-7.036c-.35-.061-.35-.565 0-.626A3.176 3.176 0 0 0 9.955.873l.02-.097c.077-.347.57-.35.65-.003l.025.113a3.192 3.192 0 0 0 2.566 2.435c.352.061.352.568 0 .63a3.192 3.192 0 0 0-2.566 2.435l-.026.112c-.079.346-.572.344-.648-.003L9.955 6.4a3.176 3.176 0 0 0-2.559-2.45Z"
      />
    </g>
  </svg>

  <svg
    v-else-if="name === 'coin-Transfer-user'"
    width="32"
    height="32"
    viewBox="0 0 24 24"
  >
    <g
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    >
      <path d="M9.019 9A6.5 6.5 0 1 1 15 14.981" />
      <path
        d="M8.5 22a6.5 6.5 0 1 1 0-13a6.5 6.5 0 0 1 0 13M22 17a3 3 0 0 1-3 3h-2m0 0l2-2m-2 2l2 2M2 7a3 3 0 0 1 3-3h2m0 0L5 6m2-2L5 2"
      />
    </g>
  </svg>

  <svg v-else-if="name === 'zakat'" width="32" height="32" viewBox="0 0 14 14">
    <g
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path
        d="m3.021 12.75l-1.914-1.914a2 2 0 0 1-.586-1.414V5.25a1 1 0 0 1 1-1v0a1 1 0 0 1 1 1v3m8.458 4.5l1.914-1.914a2 2 0 0 0 .585-1.414V5.25a1 1 0 0 0-1-1v0a1 1 0 0 0-1 1v3"
      />
      <path
        d="m3.436 10.078l-.707-.707a1 1 0 0 1 1.414-1.414L5.436 9.25a2 2 0 0 1 .585 1.414v2.086m4.543-2.672l.707-.707a1 1 0 0 0-1.414-1.414L8.564 9.25a2 2 0 0 0-.585 1.414v2.086m1.042-7.584c0-1.127-2-3.916-2-3.916s-2 2.79-2 3.916c0 .552.211 1.083.586 1.474c.375.39.884.61 1.414.61c.53 0 1.04-.22 1.415-.61a2.13 2.13 0 0 0 .585-1.474"
      />
    </g>
  </svg>

  <svg v-else-if="name === 'makka'" width="32" height="32" viewBox="0 0 48 48">
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M24 18.358c0 5.18-9.847 6.716-9.847 14.441a8.384 8.384 0 0 0 2.044 5.225"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M24 38.023H6.12V42.5H24"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M10.094 42.5c0-2.473-.89-4.477-1.987-4.477S6.12 40.027 6.12 42.5m7.947 0c0-2.473-.89-4.477-1.987-4.477s-1.986 2.004-1.986 4.477"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M18.04 42.5c0-2.473-.89-4.477-1.987-4.477s-1.986 2.004-1.986 4.477m7.946 0c0-2.473-.89-4.477-1.986-4.477S18.04 40.027 18.04 42.5m7.947 0c0-2.473-.89-4.477-1.987-4.477s-1.987 2.004-1.987 4.477M11.358 21.153l1.024-3.688h-1.024v-.839c0-1.082-.878-4.048-1.96-4.048s-1.96 2.966-1.96 4.048v.84H6.412l1.024 3.686V25.3H6.413l1.024 3.688v9.035h3.921v-9.035l1.024-3.687h-1.024ZM24 18.358c0 5.18 9.847 6.716 9.847 14.441a8.384 8.384 0 0 1-2.044 5.225"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M24 38.023h17.88V42.5H24"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M37.907 42.5c0-2.473.889-4.477 1.986-4.477s1.987 2.004 1.987 4.477m-7.947 0c0-2.473.89-4.477 1.987-4.477s1.986 2.004 1.986 4.477m-7.946 0c0-2.473.89-4.477 1.987-4.477s1.986 2.004 1.986 4.477m-7.946 0c0-2.473.89-4.477 1.986-4.477s1.987 2.004 1.987 4.477m6.682-21.347l-1.025-3.688h1.025v-.839c0-1.082.877-4.048 1.96-4.048s1.96 2.966 1.96 4.048v.84h1.025l-1.024 3.686V25.3h1.024l-1.024 3.688v9.035h-3.921v-9.035L35.617 25.3h1.025ZM9.398 12.578v-1.872m29.204 1.872v-1.872m-12.397 5.301A5.562 5.562 0 0 1 23.643 5.5a6.434 6.434 0 1 0 6.187 9.137a5.53 5.53 0 0 1-3.625 1.37"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="m26.692 6.725l.579 1.78h1.871l-1.514 1.1l.578 1.78l-1.514-1.1l-1.514 1.1l.579-1.78l-1.514-1.1h1.871z"
    />
  </svg>

  <svg
    v-else-if="name === 'wallpaper'"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <path
      fill="#bf8e55"
      d="M27.5 5.5h-9.3l-2.1 4.2H4.4v16.8h25.2v-21Zm0 4.2h-8.2l1.1-2.1h7.1Z"
    />
    <path
      fill="#a86749"
      d="M27.3 16.881a7.847 7.847 0 0 1 1.576 1.419a4.666 4.666 0 0 1 .17 6.087a5.188 5.188 0 0 1-3.163 1.765a9.328 9.328 0 0 1-3.381-.073a10.985 10.985 0 0 0-1.608-.176a.9.9 0 0 0-1.046.724v.015a.94.94 0 0 0 .18.742a10.477 10.477 0 0 0 .848 1.108a2.175 2.175 0 0 1 .529.99a.787.787 0 0 1-.491.946a6.371 6.371 0 0 1-3.139.552a14.984 14.984 0 0 1-7.736-2.555a6.838 6.838 0 0 1-2.928-4.416a5.869 5.869 0 0 1 1-4.544a10.187 10.187 0 0 1 4.317-3.6a15.053 15.053 0 0 1 11.67-.6c.04.02 3.131 1.677 3.202 1.616"
    />
    <path
      fill="#3783ff"
      d="M11.247 22.676a2.465 2.465 0 0 1 1.594.514a1.126 1.126 0 0 1 .321 1.533a1.091 1.091 0 0 1-.321.328a2.767 2.767 0 0 1-3.195 0a1.129 1.129 0 0 1-.33-1.535a1.089 1.089 0 0 1 .337-.342a2.459 2.459 0 0 1 1.594-.498"
    />
    <path
      fill="#4de94c"
      d="M10.965 21.431a1.924 1.924 0 0 1-1.171-.371a.9.9 0 0 1-.3-1.214a.867.867 0 0 1 .29-.3a2.113 2.113 0 0 1 2.458.025a.887.887 0 0 1 .235 1.212a.853.853 0 0 1-.226.234a1.948 1.948 0 0 1-1.286.414"
    />
    <path
      fill="#fe0"
      d="M14.11 18.49a1.462 1.462 0 0 1-1.072-.385a.719.719 0 0 1-.087-1a.732.732 0 0 1 .087-.089a1.656 1.656 0 0 1 2.124 0a.721.721 0 0 1 .087 1a.678.678 0 0 1-.128.123a1.492 1.492 0 0 1-1.011.351"
    />
    <path
      fill="#4c1ac6"
      d="M15.859 25.412a2.8 2.8 0 0 1 1.793.568a1.235 1.235 0 0 1 .373 1.677a1.214 1.214 0 0 1-.373.382a3.158 3.158 0 0 1-3.6 0a1.238 1.238 0 0 1-.39-1.678a1.214 1.214 0 0 1 .4-.4a2.8 2.8 0 0 1 1.797-.549"
    />
    <path
      fill="#2a3e4f"
      d="M31 13.466a5.779 5.779 0 0 1-1.151 1.909a46.887 46.887 0 0 1-3.749 4.084a.512.512 0 0 1-.537.189a.677.677 0 0 1-.251-.153q-.429-.409-.844-.833a.473.473 0 0 1-.076-.653a.557.557 0 0 1 .052-.057a.664.664 0 0 1 .056-.052a48.322 48.322 0 0 1 4.1-3.7a8.494 8.494 0 0 1 1.42-.946a2.566 2.566 0 0 1 .508-.189a.353.353 0 0 1 .463.187v.014Z"
    />
    <path
      fill="#7e8c8d"
      d="M20 22.963a.08.08 0 0 1 .03.006a2.259 2.259 0 0 0 2.977-.465a1.533 1.533 0 0 0 .411-1.21a1.17 1.17 0 0 0-1-1.006a1.025 1.025 0 0 0-.923.408a1.546 1.546 0 0 0-.284.657A2.573 2.573 0 0 1 20 22.938Z"
    />
    <path
      fill="#f89b36"
      d="M25.16 19.792c-.325-.327-.655-.651-.984-.976a.236.236 0 0 0-.33-.053h-.006a.241.241 0 0 0-.063.072q-.417.544-.83 1.092a.219.219 0 0 0 .008.3l.011.01q.369.366.738.728a.224.224 0 0 0 .316.035c.375-.277.751-.554 1.12-.839a.8.8 0 0 0 .136-.2a1.2 1.2 0 0 0-.116-.169"
    />
    <path
      fill="#ff8c00"
      d="M17.865 17.121a1.145 1.145 0 0 1-.859-.321a.617.617 0 0 1-.048-.856a.567.567 0 0 1 .048-.05a1.286 1.286 0 0 1 1.7 0a.617.617 0 0 1 .048.857a.583.583 0 0 1-.08.077a1.167 1.167 0 0 1-.809.293"
    />
    <path
      fill="#8f9fa0"
      d="M20 22.963s3.915-1.136 2.659-2.614c0 0-.857-.393-1.455 1.007A3.921 3.921 0 0 1 20 22.963"
    />
    <path
      fill="#e9bb42"
      d="m23.306 20.585l1.373-1.272l-.5-.5a.239.239 0 0 0-.336-.045l-.008.006a.255.255 0 0 0-.055.063c-.2.259-1.152 1.07-.812 1.407Z"
    />
    <path
      fill="#32495d"
      d="M24.878 19.073L31 13.254s.041-.393-.468-.2s-.8-.177-6.094 4.9a.442.442 0 0 0 .024.71Z"
    />
    <path
      fill="#f60000"
      d="M21.721 17.41a1.149 1.149 0 0 1-.858-.321a.617.617 0 0 1-.048-.857a.555.555 0 0 1 .048-.049a1.286 1.286 0 0 1 1.7 0a.617.617 0 0 1 .048.855a.549.549 0 0 1-.082.078a1.161 1.161 0 0 1-.808.294"
    />
  </svg>

  <svg v-else-if="name === 'azkar'" width="32" height="32" viewBox="0 0 48 48">
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M23.224 13.542c2.496-2.86 4.767-5.13 3.701-6.28S8.613 12.515 9.586 14.187c.58.996 15.989 12.179 17.509 13.078c1.785 1.056 4.653-.18 4.4-2.144L29.168 7.11s1.178 1.582 1.542 2.675m4.374 16.722c-.252-1.963-2.327-18.012-2.327-18.012s1.178 1.582 1.542 2.676"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M28.383 33.87c0-6.218-2.09-20.011-2.09-20.011s1.178 1.581 1.543 2.675m-5.766-1.987c-.364-1.094-1.541-2.676-1.541-2.676s.593 7.208 4.041 8.638c-9.246-4.479-13.647 10.178-17.642 5.888c-2.851-3.06 2.27-7.36 2.27-7.36"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M37.916 14.03c-.365-1.093-1.542-2.675-1.542-2.675S38.4 29.25 38.832 33.87c.205 2.201-3.874 3.21-5.388-.49s-.126-4.753.799-4.753s2.44 3.084 0 4.514s-6.505 2.468-7.738 3.897s-3.393 4.71-4.823 4.71s-4.233-1.541-1.037-7.878m20.804-2.72c-.253-3.28-1.963-16.57-1.963-16.57s1.178 1.581 1.542 2.675M13.993 8.944c1.724-1.073 5.278-1.745 7.129-3.196M8.981 27.193C6.682 29.72 7.327 34.85 10.02 34.01c1.005-.314 2.215-2.404 4.233-3.308c3.387-1.516 7.719-2.29 7.458-4.71c-.336-3.126-3.336-4.945-3.336-4.945"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M25.818 29.019c-1.437-.635-1.907-1.367-1.907-1.367c1.164 2.6 2.061 4.184 2.09 5.432s-6.407 5.236-9.17 5.236c-3.216 0-5.57-2.312-4.656-6.15m-2.04-17.435c-2.114.98-3.425 5.617-1.813 5.149"
    />
    <circle
      cx="24"
      cy="24"
      r="21.5"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <svg
    v-else-if="name === 'hadith'"
    width="28"
    height="32"
    viewBox="0 0 448 512"
  >
    <path
      fill="currentColor"
      d="M352 0c53 0 96 43 96 96v320c0 53-43 96-96 96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32v-64c-17.7 0-32-14.3-32-32V32C0 14.3 14.3 0 32 0h32zm0 384H96v64h256c17.7 0 32-14.3 32-32s-14.3-32-32-32m-77.9-233.8l-8.9 21.4l-23.1 1.9c-5.7.5-8 7.5-3.7 11.2l17.6 15.1l-5.4 22.6c-1.3 5.5 4.7 9.9 9.6 6.9l19.8-12.1l19.8 12.1c4.9 3 10.9-1.4 9.6-6.9l-5.4-22.6l17.6-15.1c4.3-3.7 2-10.8-3.7-11.2l-23.1-1.9l-8.9-21.4c-2.2-5.3-9.6-5.3-11.8 0M96 192c0 70.7 57.3 128 128 128c25.6 0 49.5-7.5 69.5-20.5c3.2-2.1 4.5-6.2 3.1-9.7s-5.2-5.6-9-4.8c-6.1 1.2-12.5 1.9-19 1.9c-52.4 0-94.9-42.5-94.9-94.9s42.5-94.9 94.9-94.9c6.5 0 12.8.7 19 1.9c3.8.8 7.5-1.3 9-4.8s.2-7.6-3.1-9.7c-20-13-43.9-20.5-69.5-20.5c-70.7 0-128 57.3-128 128"
    />
  </svg>

  <svg
    v-else-if="name === 'new-investment'"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 14 14"
  >
    <g fill="none" stroke="currentColor" stroke-linecap="round">
      <path
        stroke-linejoin="round"
        d="M6.338 3.7a1 1 0 0 0-.943-.668H4.62a.893.893 0 0 0-.19 1.765l1.178.258a1 1 0 0 1-.214 1.977h-.667a1 1 0 0 1-.943-.666m1.278-3.334v-1m0 6v-1m1.907 6.467v-5.25a1.25 1.25 0 0 1 1.25-1.25v0a1.25 1.25 0 0 1 1.25 1.25v2.75h2a2 2 0 0 1 2 2v.5"
      />
      <path d="M5.063 9.564a4.531 4.531 0 1 1 4.489-3.911" />
    </g>
  </svg>

  <svg v-else-if="name === 'dua'" width="32" height="32" viewBox="0 0 72 72">
    <path
      fill="#EDC0A2"
      d="M44.3 11.6c-.2 0-.5 0-.7.1V6.4c0-2.2-1.8-4-4-4c-1.7 0-3.1 1-3.7 2.4c-.6-1.4-2-2.4-3.7-2.4c-2.2 0-4 1.8-4 4v5.3c-.2 0-.5-.1-.7-.1c-2.2 0-4 1.8-4 4v31.7c0 2.2 1.8 4 4 4c1.1 0 2.2-.5 2.9-1.2c.5.3 1.2.5 1.8.5v.2h10.1c.6.3 1.2.5 2 .5c2.2 0 4-1.8 4-4V15.6c0-2.2-1.7-4-4-4"
    />
    <path
      fill="#357BA8"
      d="M66.7 44.5c-.3-.5-.6-.9-1-1.3c-3.5-3.5-10.8-1.7-16.4 3.9c-5.6 5.6-7.4 13-3.9 16.4c.3.3.5.5.8.7L54 72h17.8l.2-22.2z"
    />
    <path
      fill="#FFD3B6"
      d="M61.1 42.5c-.2-.4-.5-.8-.9-1.1c-6.8-6-14.5-14.8-14.5-17.9V7.7c0-2.2-1.8-4-4-4s-4 1.8-4 4v32.5c0 12.5 7.3 19.7 7.6 20c.6.5 1.4.9 2.2 1.1h.8c1.8 0 5.5-.7 10-5.2c5.2-5.1 4.2-10.9 2.8-13.6"
    />
    <path
      fill="#357BA8"
      d="M22.6 47.1c-5.6-5.6-13-7.4-16.4-3.9c-.4.4-.7.8-1 1.3l-5.3 5.3L0 72h17.8l7.8-7.8c.3-.2.6-.4.8-.7c3.6-3.5 1.8-10.8-3.8-16.4"
    />
    <path
      fill="#FFD3B6"
      d="M30.2 3.7c-2.2 0-4 1.8-4 4v15.8c0 3.1-7.6 11.9-14.5 17.9c-.4.3-.7.7-.9 1.1c-1.4 2.7-2.4 8.5 2.7 13.7c4.5 4.5 8.2 5.2 10 5.2h.8c.8-.1 1.6-.5 2.2-1.1c.3-.3 7.6-7.4 7.6-20V7.7c.1-2.2-1.7-4-3.9-4"
    />
    <path
      fill="#00BEEA"
      d="M54.5 13.8c.1 0 .1 0 .2-.1l7.1-4c.1-.1.2-.2.2-.3c0-.1 0-.2-.1-.3L58.8 6c-.1 0-.2-.1-.4 0c-.1 0-.2.1-.3.2l-4 7.1c-.1.2-.1.3.1.5zm-44-4l7.1 4c.1 0 .1.1.2.1c.3 0 .4-.2.4-.4c0-.1 0-.2-.1-.3l-3.9-7c-.1-.2-.2-.2-.3-.2c-.1 0-.2 0-.3.1l-3.1 3.1c-.1.1-.1.2-.1.3c0 .1 0 .2.1.3m51.6 8.9c-.1-.1-.2-.1-.3-.1L54 20.8c-.2 0-.3.2-.3.4s.1.3.3.4l7.8 2.2h.1c.1 0 .2 0 .2-.1c.1-.1.2-.2.2-.3V19c-.1-.1-.1-.3-.2-.3m-43.7 2.1l-7.8-2.2c-.1 0-.2 0-.3.1c-.2 0-.3.2-.3.3v4.3c0 .1.1.2.2.3c.1.1.2.1.2.1h.1l7.8-2.2c.2 0 .3-.2.3-.4s-.1-.3-.2-.3"
    />
  </svg>

  <svg
    v-else-if="name === 'user-profile'"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <path
      fill="currentColor"
      d="M12 4a5 5 0 1 1-5 5a5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7a7 7 0 0 0-7-7zm10 28h-2v-5a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v5H2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7zm0-26h10v2H22zm0 5h10v2H22zm0 5h7v2h-7z"
    />
  </svg>

  <svg
    v-else-if="name === 'Staking-Wallets'"
    width="32"
    height="32"
    viewBox="0 0 24 24"
  >
    <g fill="none" fill-rule="evenodd">
      <path
        d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"
      />
      <path
        fill="currentColor"
        d="M5.5 10.5V5.415A1.5 1.5 0 0 1 6 2.5h6a9.5 9.5 0 0 1 0 19H6a1.5 1.5 0 0 1-.5-2.915V13.5H4a1.5 1.5 0 0 1 0-3zm3 3v5H12a6.5 6.5 0 1 0 0-13H8.5v5H13a1.5 1.5 0 0 1 0 3z"
      />
    </g>
  </svg>

  <svg
    v-else-if="name === 'Staking-Roi'"
    width="32"
    height="32"
    viewBox="0 0 24 24"
  >
    <g
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    >
      <path
        d="M16 13c-2.761 0-5-1.12-5-2.5S13.239 8 16 8s5 1.12 5 2.5s-2.239 2.5-5 2.5m-5 1.5c0 1.38 2.239 2.5 5 2.5s5-1.12 5-2.5m-18-5C3 10.88 5.239 12 8 12c1.126 0 2.165-.186 3-.5M3 13c0 1.38 2.239 2.5 5 2.5c1.126 0 2.164-.186 3-.5"
      />
      <path
        d="M3 5.5v11C3 17.88 5.239 19 8 19c1.126 0 2.164-.186 3-.5m2-10v-3m-2 5v8c0 1.38 2.239 2.5 5 2.5s5-1.12 5-2.5v-8"
      />
      <path
        d="M8 8C5.239 8 3 6.88 3 5.5S5.239 3 8 3s5 1.12 5 2.5S10.761 8 8 8"
      />
    </g>
  </svg>

  <svg
    v-else-if="name === 'team-member'"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 20 20"
  >
    <path
      fill="currentColor"
      d="M10 3a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3ZM7.5 4.5a2.5 2.5 0 1 1 5 0a2.5 2.5 0 0 1-5 0Zm8-.5a1 1 0 1 0 0 2a1 1 0 0 0 0-2Zm-2 1a2 2 0 1 1 4 0a2 2 0 0 1-4 0Zm-10 0a1 1 0 1 1 2 0a1 1 0 0 1-2 0Zm1-2a2 2 0 1 0 0 4a2 2 0 0 0 0-4Zm.6 11.998A2 2 0 0 1 3 13V9.25A.25.25 0 0 1 3.25 9h1.764c.04-.367.17-.708.365-1H3.25C2.56 8 2 8.56 2 9.25V13a3 3 0 0 0 3.404 2.973a4.963 4.963 0 0 1-.304-.975Zm9.496.975A3 3 0 0 0 18 13V9.25C18 8.56 17.44 8 16.75 8h-2.129c.196.292.325.633.365 1h1.764a.25.25 0 0 1 .25.25V13a2 2 0 0 1-2.1 1.998a4.966 4.966 0 0 1-.304.975ZM7.25 8C6.56 8 6 8.56 6 9.25V14a4 4 0 0 0 8 0V9.25C14 8.56 13.44 8 12.75 8h-5.5ZM7 9.25A.25.25 0 0 1 7.25 9h5.5a.25.25 0 0 1 .25.25V14a3 3 0 1 1-6 0V9.25Z"
    />
  </svg>

  <svg
    v-else-if="name === 'Total-Earning'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 448 512"
  >
    <path
      d="M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm240-64H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'mode'"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M12 3a9 9 0 1 0 9 9c0-.46-.04-.92-.1-1.36a5.389 5.389 0 0 1-4.4 2.26a5.403 5.403 0 0 1-3.14-9.8c-.44-.06-.9-.1-1.36-.1z"
    />
  </svg>

  <svg
    v-else-if="name === 'sessions'"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 14 14"
  >
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M5.5 9h-5v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1Zm8 0h-5v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1Zm-8 0h3m5 0V3a2 2 0 0 0-2-2h-1M.5 9V3a2 2 0 0 1 2-2h1"
    />
  </svg>

  <svg
    v-else-if="name === 'check'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
  >
    <path
      d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256S119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'host'"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <path
      fill="#fd5750"
      fill-rule="evenodd"
      d="M2 22.419h4.956L5.42 27H2Zm0-8.709h7.875L8.34 18.29H2ZM2 5h10.794l-1.535 4.581H2Zm15.679 0H30v4.581H16.143Zm-4.455 13.291l1.536-4.581H30v4.581Zm-1.383 4.128H30V27H10.305Z"
    />
  </svg>
  <svg
    v-else-if="name === 'nameversion'"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 48 48"
  >
    <g
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="4"
    >
      <path
        fill="#2F88FF"
        stroke="#000"
        d="M10 44H38C39.1046 44 40 43.1046 40 42V14H30V4H10C8.89543 4 8 4.89543 8 6V42C8 43.1046 8.89543 44 10 44Z"
      />
      <path stroke="#000" d="M30 4L40 14" />
      <path stroke="#fff" d="M17 25L31 25" />
      <path stroke="#fff" d="M17 31L31 31" />
      <path stroke="#fff" d="M31 25L26 20" />
      <path stroke="#fff" d="M22 36L17 31" />
    </g>
  </svg>

  <svg
    v-else-if="name === 'bversion'"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M9.375 15.025L8 14.25v-4.5l4-2.25l1.35.675ZM12 16.5l-1.3-.75l4-6.9l1.3.65v4.75Zm5.25-8.05L12 5.575L6.775 8.45L2.75 6.075L12 1l9.25 5.075ZM11 23l-9-5V7.375l4 2.35v5.925l5 2.75Zm2 0v-4.575l5-2.775v-5.9l4-2.375V18Z"
    />
  </svg>

  <svg
    v-else-if="name === 'mlm'"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 48 48"
  >
    <mask id="ipTTreeList0">
      <g fill="none" stroke="#fff" stroke-linejoin="round" stroke-width="4">
        <path
          fill="#555"
          d="M38 20H18v8h20v-8ZM32 6H18v8h14V6Zm12 28H18v8h26v-8Z"
        />
        <path stroke-linecap="round" d="M17 10H5m12 14H5m12 14H5m0 6V4" />
      </g>
    </mask>
    <path fill="currentColor" d="M0 0h48v48H0z" mask="url(#ipTTreeList0)" />
  </svg>

  <svg
    v-else-if="name === 'serverDetails'"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <g fill="none">
      <rect width="28" height="28" x="2" y="2" fill="#00A6ED" rx="4" />
      <path
        fill="#fff"
        d="M16 9.971a1.978 1.978 0 1 0 0-3.956a1.978 1.978 0 0 0 0 3.956Zm1.61 3.747a1.75 1.75 0 1 0-3.5 0v10.59a1.75 1.75 0 1 0 3.5 0v-10.59Z"
      />
    </g>
  </svg>

  <svg
    v-else-if="name === 'laravel'"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 256 256"
  >
    <g fill="none">
      <rect width="256" height="256" fill="#F4F2ED" rx="60" />
      <path
        fill="#FF2D20"
        fill-rule="evenodd"
        d="M215.846 78.314c.064.243.098.494.098.747v39.199c0 .503-.131.997-.379 1.432a2.838 2.838 0 0 1-1.037 1.047l-32.446 18.942v37.545a2.873 2.873 0 0 1-1.409 2.48l-67.728 39.535c-.155.089-.324.146-.493.207c-.064.022-.123.061-.19.079a2.81 2.81 0 0 1-1.445 0c-.077-.022-.148-.065-.222-.093c-.155-.057-.317-.107-.465-.193l-67.714-39.535a2.848 2.848 0 0 1-1.036-1.047a2.893 2.893 0 0 1-.38-1.433V59.629c0-.258.035-.508.099-.75c.02-.083.07-.158.098-.24c.053-.15.102-.303.18-.443c.053-.093.13-.168.194-.253c.08-.115.155-.233.25-.333c.08-.082.187-.143.278-.214c.102-.086.194-.179.31-.247h.004L76.27 37.382a2.796 2.796 0 0 1 2.819 0l33.859 19.767h.007c.112.072.208.161.31.243c.091.072.193.136.274.215c.099.103.17.221.254.336c.06.085.141.16.19.253c.081.143.127.293.184.443c.028.082.077.157.098.243c.065.244.098.495.099.747v73.45l28.214-16.473v-37.55c0-.25.035-.503.099-.742c.025-.086.07-.161.099-.243c.056-.15.105-.304.183-.443c.053-.093.13-.168.19-.254c.085-.114.155-.232.254-.332c.081-.082.183-.143.275-.215c.105-.085.197-.178.31-.246h.004l33.862-19.768a2.789 2.789 0 0 1 2.818 0l33.859 19.768c.12.072.211.16.317.243c.088.071.19.136.271.214c.099.104.169.222.254.336c.063.086.141.16.19.254c.081.14.127.293.183.443c.032.082.078.157.099.243Zm-5.546 38.292V84.009l-11.849 6.916l-16.369 9.557v32.597l28.221-16.473h-.003Zm-33.859 58.966v-32.618l-16.101 9.325l-45.979 26.609v32.925l62.08-36.241ZM46.644 64.577v110.995l62.073 36.238v-32.919l-32.428-18.61l-.01-.007l-.015-.007c-.109-.064-.2-.157-.303-.236c-.088-.071-.19-.128-.267-.207l-.007-.01c-.092-.09-.156-.2-.233-.301c-.07-.096-.155-.178-.211-.278l-.004-.011c-.064-.107-.103-.236-.148-.357c-.046-.107-.106-.207-.134-.322v-.004c-.035-.135-.042-.278-.057-.418c-.014-.107-.042-.214-.042-.321V81.051L58.493 71.49l-11.849-6.91v-.003Zm31.04-21.415L49.474 59.63l28.203 16.466l28.207-16.47l-28.207-16.463h.007Zm14.671 102.764l16.366-9.553V64.577l-11.85 6.917l-16.368 9.556v71.797l11.852-6.921Zm86.909-83.332l-28.208 16.467l28.208 16.466l28.203-16.47l-28.203-16.463Zm-2.823 37.888l-16.369-9.557l-11.848-6.916v32.597l16.365 9.553l11.852 6.92v-32.597Zm-64.905 73.458l41.373-23.952l20.682-11.968l-28.186-16.456l-32.453 18.946l-29.578 17.267l28.162 16.163Z"
        clip-rule="evenodd"
      />
    </g>
  </svg>

  <svg
    v-else-if="name === 'php'"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <path
      fill="#d33e44"
      d="m16 13.819l10.949 2.719C28.855 15.792 30 14.846 30 13.819V9.445c0-2.409-6.27-4.369-14-4.369S2 7.035 2 9.445v4.375c0 2.411 6.267 4.369 14 4.369v-4.37Z"
    />
    <path
      fill="#fff"
      d="M26.948 16.538L16 13.818v4.37l10.949 2.72C28.854 20.16 30 19.216 30 18.188v-4.37c0 1.028-1.146 1.973-3.052 2.72ZM2 13.818v4.37c0 2.411 6.267 4.366 14 4.366v-4.366c-7.733 0-14-1.96-14-4.37Z"
    />
    <path
      fill="#d33e44"
      d="M26.948 20.908L16 18.188v4.37l10.949 2.72c1.905-.747 3.051-1.692 3.051-2.72v-4.37c0 1.028-1.146 1.973-3.052 2.72ZM2 18.188v4.37c0 2.411 6.267 4.366 14 4.366v-4.366c-7.733 0-14-1.958-14-4.37Z"
    />
  </svg>

  <svg
    v-else-if="name === 'http'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <path
      opacity=".3"
      d="M6 20h12V10H6v10zm6-7c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2z"
      fill="currentColor"
    ></path>
    <path
      d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2s-2 .9-2 2s.9 2 2 2z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'country'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
  >
    <path
      d="M243.2 189.9V258c26.1 5.9 49.3 15.6 73.6 22.3v-68.2c-26-5.8-49.4-15.5-73.6-22.2zm223.3-123c-34.3 15.9-76.5 31.9-117 31.9C296 98.8 251.7 64 184.3 64c-25 0-47.3 4.4-68 12c2.8-7.3 4.1-15.2 3.6-23.6C118.1 24 94.8 1.2 66.3 0C34.3-1.3 8 24.3 8 56c0 19 9.5 35.8 24 45.9V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-94.4c28.3-12.1 63.6-22.1 114.4-22.1c53.6 0 97.8 34.8 165.2 34.8c48.2 0 86.7-16.3 122.5-40.9c8.7-6 13.8-15.8 13.8-26.4V95.9c.1-23.3-24.2-38.8-45.4-29zM169.6 325.5c-25.8 2.7-50 8.2-73.6 16.6v-70.5c26.2-9.3 47.5-15 73.6-17.4zM464 191c-23.6 9.8-46.3 19.5-73.6 23.9V286c24.8-3.4 51.4-11.8 73.6-26v70.5c-25.1 16.1-48.5 24.7-73.6 27.1V286c-27 3.7-47.9 1.5-73.6-5.6v67.4c-23.9-7.4-47.3-16.7-73.6-21.3V258c-19.7-4.4-40.8-6.8-73.6-3.8v-70c-22.4 3.1-44.6 10.2-73.6 20.9v-70.5c33.2-12.2 50.1-19.8 73.6-22v71.6c27-3.7 48.4-1.3 73.6 5.7v-67.4c23.7 7.4 47.2 16.7 73.6 21.3v68.4c23.7 5.3 47.6 6.9 73.6 2.7V143c27-4.8 52.3-13.6 73.6-22.5z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'upload'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
  >
    <path
      d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2zm2.354 5.146a.5.5 0 0 1-.708.708L8.5 6.707V10.5a.5.5 0 0 1-1 0V6.707L6.354 7.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2z"
    />
  </svg>
  <svg
    v-else-if="name === 'security'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32"
  >
    <path
      d="M20 20h-6v-3a2 2 0 0 1 4 0h2a4 4 0 0 0-8 0v3a2.002 2.002 0 0 0-2 2v6a2.002 2.002 0 0 0 2 2h8a2.002 2.002 0 0 0 2-2v-6a2.002 2.002 0 0 0-2-2zm0 8h-8v-6h8z"
      fill="currentColor"
    ></path>
    <path
      d="M16 8a8.97 8.97 0 0 0-6.36 2.64l1.412 1.413a6.989 6.989 0 0 1 9.895 0l1.414-1.414A8.972 8.972 0 0 0 16 8z"
      fill="currentColor"
    ></path>
    <path
      d="M6.105 7.105l1.414 1.414a11.98 11.98 0 0 1 16.962 0l1.414-1.414a13.978 13.978 0 0 0-19.79 0z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'account-setting'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <path
      d="M10.67 13.02c-.22-.01-.44-.02-.67-.02c-2.42 0-4.68.67-6.61 1.82c-.88.52-1.39 1.5-1.39 2.53V20h9.26a6.963 6.963 0 0 1-.59-6.98z"
      fill="currentColor"
    ></path>
    <circle cx="10" cy="8" r="4" fill="currentColor"></circle>
    <path
      d="M20.75 16c0-.22-.03-.42-.06-.63l1.14-1.01l-1-1.73l-1.45.49c-.32-.27-.68-.48-1.08-.63L18 11h-2l-.3 1.49c-.4.15-.76.36-1.08.63l-1.45-.49l-1 1.73l1.14 1.01c-.03.21-.06.41-.06.63s.03.42.06.63l-1.14 1.01l1 1.73l1.45-.49c.32.27.68.48 1.08.63L16 21h2l.3-1.49c.4-.15.76-.36 1.08-.63l1.45.49l1-1.73l-1.14-1.01c.03-.21.06-.41.06-.63zM17 18c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'email-setting'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <path
      d="M12 21.95h5v-2h-5c-4.34 0-8-3.66-8-8s3.66-8 8-8s8 3.66 8 8v1.43c0 .79-.71 1.57-1.5 1.57s-1.5-.78-1.5-1.57v-1.43c0-2.76-2.24-5-5-5s-5 2.24-5 5s2.24 5 5 5c1.38 0 2.64-.56 3.54-1.47c.65.89 1.77 1.47 2.96 1.47c1.97 0 3.5-1.6 3.5-3.57v-1.43c0-5.52-4.48-10-10-10s-10 4.48-10 10s4.48 10 10 10zm0-7c-1.66 0-3-1.34-3-3s1.34-3 3-3s3 1.34 3 3s-1.34 3-3 3z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'report'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <path
      d="M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-8-4h2v2h2v-2h2v-2h-2v-2h-2v2h-2z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'arrow-right-circle'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
  >
    <path
      fill-rule="evenodd"
      d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
    />
  </svg>

  <svg
    v-else-if="name === 'sort-down'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      d="M3 3a1 1 0 000 2h11a1 1 0 100-2H3zM3 7a1 1 0 000 2h5a1 1 0 000-2H3zM3 11a1 1 0 100 2h4a1 1 0 100-2H3zM13 16a1 1 0 102 0v-5.586l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 101.414 1.414L13 10.414V16z"
    />
  </svg>

  <svg
    v-else-if="name === 'sort-up'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      d="M3 3a1 1 0 000 2h11a1 1 0 100-2H3zM3 7a1 1 0 000 2h7a1 1 0 100-2H3zM3 11a1 1 0 100 2h4a1 1 0 100-2H3zM15 8a1 1 0 10-2 0v5.586l-1.293-1.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L15 13.586V8z"
    />
  </svg>

  <svg
    v-else-if="name === 'check-circle'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
  >
    <path
      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
    />
    <path
      d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"
    />
  </svg>

  <!-- Tags: cardboard, package, box -->
  <svg
    v-else-if="name === 'package'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
  >
    <path
      d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5l2.404.961L10.404 2l-2.218-.887zm3.564 1.426L5.596 5 8 5.961 14.154 3.5l-2.404-.961zm3.25 1.7-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z"
    />
  </svg>

  <!-- Tags: gear, settings -->
  <svg
    v-else-if="name === 'gear'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
    ></path>
    <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
  </svg>

  <!-- Tags: menu, bars, horizontal bars -->
  <svg
    v-else-if="name === 'menu'"
    viewBox="0 0 24 24"
    stroke="currentColor"
    aria-hidden="true"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M4 6h16M4 12h8m-8 6h16"
    />
  </svg>

  <!-- Tags: page, template -->
  <svg
    v-else-if="name === 'page'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    stroke-width="2"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"
    />
  </svg>

  <!-- Tags: page-fill, template-fill -->
  <svg
    v-else-if="name === 'page-fill'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"
    />
  </svg>

  <svg
    v-else-if="name === 'order-list'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 1024 1024"
  >
    <path
      d="M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 1 0 112 0a56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0a56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0a56 56 0 1 0-112 0z"
      fill="currentColor"
    ></path>
  </svg>

  <!-- Tags: annotation, testimonials, writing -->
  <svg
    v-else-if="name === 'annotation'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fill-rule="evenodd"
      d="M18 13V5a2 2 0 00-2-2H4a2 2 0 00-2 2v8a2 2 0 002 2h3l3 3 3-3h3a2 2 0 002-2zM5 7a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1zm1 3a1 1 0 100 2h3a1 1 0 100-2H6z"
      clip-rule="evenodd"
    />
  </svg>

  <!-- Tags: caret, right -->
  <svg
    v-else-if="name === 'caret-right'"
    viewBox="0 0 20 20"
    aria-hidden="true"
  >
    <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
  </svg>

  <!-- Tags: inventory, stocks, stack, list -->
  <svg
    v-else-if="name === 'stack'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <g
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M12 4L4 8l8 4l8-4l-8-4"></path>
      <path d="M4 12l8 4l8-4"></path>
      <path d="M4 16l8 4l8-4"></path>
    </g>
  </svg>

  <!-- Tags: order -->
  <svg
    v-else-if="name === 'outbound-order'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <path
      d="M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8s-8-3.59-8-8s3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm1.88 9.54L8.92 16.5l-1.41-1.41l4.96-4.96L10.34 8l5.65.01l.01 5.65l-2.12-2.12z"
      fill="currentColor"
    ></path>
  </svg>

  <!-- Tags: controls, settings, permissions, roles -->
  <svg
    v-else-if="name === 'border-control'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32"
  >
    <path
      d="M26 8l-1.41 1.41L27.17 12H16a5.967 5.967 0 0 0-4 1.54V6.83l2.59 2.58L16 8l-5-5l-5 5l1.41 1.41L10 6.83V18a5.969 5.969 0 0 0 1.54 4H4.83l2.58-2.59L6 18l-5 5l5 5l1.41-1.41L4.83 24H16a5.99 5.99 0 0 0 4.46-10h6.71l-2.58 2.59L26 18l5-5zm-6 10a4 4 0 1 1-4-4a4.005 4.005 0 0 1 4 4z"
      fill="currentColor"
    ></path>
  </svg>

  <!-- Tags: pencil, edit -->
  <svg
    v-else-if="name === 'pencil'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
  >
    <path
      d="M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4L.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3l262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3l-31.1-31.1L51.7 376H88v48z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'excel'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 384 512"
  >
    <path
      d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm212-240h-28.8c-4.4 0-8.4 2.4-10.5 6.3c-18 33.1-22.2 42.4-28.6 57.7c-13.9-29.1-6.9-17.3-28.6-57.7c-2.1-3.9-6.2-6.3-10.6-6.3H124c-9.3 0-15 10-10.4 18l46.3 78l-46.3 78c-4.7 8 1.1 18 10.4 18h28.9c4.4 0 8.4-2.4 10.5-6.3c21.7-40 23-45 28.6-57.7c14.9 30.2 5.9 15.9 28.6 57.7c2.1 3.9 6.2 6.3 10.6 6.3H260c9.3 0 15-10 10.4-18L224 320c.7-1.1 30.3-50.5 46.3-78c4.7-8-1.1-18-10.3-18z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'download'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 16 16"
  >
    <g fill="none">
      <path
        d="M3.5 13h9a.75.75 0 0 1 .102 1.493l-.102.007h-9a.75.75 0 0 1-.102-1.493L3.5 13h9h-9zM7.898 1.007L8 1a.75.75 0 0 1 .743.648l.007.102v7.688l2.255-2.254a.75.75 0 0 1 .977-.072l.084.072a.75.75 0 0 1 .072.977l-.072.084L8.53 11.78a.75.75 0 0 1-.976.073l-.084-.073l-3.536-3.535a.75.75 0 0 1 .977-1.133l.084.072L7.25 9.44V1.75a.75.75 0 0 1 .648-.743L8 1l-.102.007z"
        fill="currentColor"
      ></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'box-arrow-up'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 20 20"
  >
    <g fill="none">
      <path
        d="M11.3 2.48a3.5 3.5 0 0 0-2.6 0L2.943 4.785A1.5 1.5 0 0 0 2 6.176v7.646a1.5 1.5 0 0 0 .943 1.393L8.7 17.518a3.5 3.5 0 0 0 1.376.25a5.495 5.495 0 0 1-.614-1.058a2.49 2.49 0 0 1-.39-.12l-5.758-2.303A.5.5 0 0 1 3 13.822V6.238l6.5 2.6v3.367a5.51 5.51 0 0 1 1-1.48V8.837l6.5-2.6v3.361c.358.183.693.404 1 .658v-4.08a1.5 1.5 0 0 0-.943-1.393L11.3 2.48zm-2.228.93a2.5 2.5 0 0 1 1.857 0l5.225 2.09l-2.279.91l-6.154-2.46l1.35-.54zM6.375 4.487l6.154 2.461L10 7.961L3.846 5.499l2.529-1.011zM14.5 18.999a4.5 4.5 0 1 0 0-9a4.5 4.5 0 0 0 0 9zm.351-6.855l.003.002l2 2a.5.5 0 1 1-.708.707L15 13.707V16.5a.5.5 0 0 1-1 0v-2.793l-1.146 1.146a.5.5 0 1 1-.708-.707l2-2a.5.5 0 0 1 .351-.146h.006a.498.498 0 0 1 .348.144z"
        fill="currentColor"
      ></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'assignment-outline'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <path
      d="M7 15h7v2H7zm0-4h10v2H7zm0-4h10v2H7zm12-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04a2.008 2.008 0 0 0-1.44 1.19c-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55c.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75s-.75-.34-.75-.75s.34-.75.75-.75zM19 19H5V5h14v14z"
      fill="currentColor"
    ></path>
  </svg>

  <!-- Tags: file, attachment -->
  <svg
    v-else-if="name === 'file'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <path
      d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5a2.5 2.5 0 0 1 5 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5a2.5 2.5 0 0 0 5 0V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'pdf'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32"
  >
    <path d="M30 18v-2h-6v10h2v-4h3v-2h-3v-2h4z" fill="currentColor"></path>
    <path
      d="M19 26h-4V16h4a3.003 3.003 0 0 1 3 3v4a3.003 3.003 0 0 1-3 3zm-2-2h2a1.001 1.001 0 0 0 1-1v-4a1.001 1.001 0 0 0-1-1h-2z"
      fill="currentColor"
    ></path>
    <path
      d="M11 16H6v10h2v-3h3a2.003 2.003 0 0 0 2-2v-3a2.002 2.002 0 0 0-2-2zm-3 5v-3h3l.001 3z"
      fill="currentColor"
    ></path>
    <path
      d="M22 14v-4a.91.91 0 0 0-.3-.7l-7-7A.909.909 0 0 0 14 2H4a2.006 2.006 0 0 0-2 2v24a2 2 0 0 0 2 2h16v-2H4V4h8v6a2.006 2.006 0 0 0 2 2h6v2zm-8-4V4.4l5.6 5.6z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'arrow-bar-up'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <g
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M12 4v10"></path>
      <path d="M12 4l4 4"></path>
      <path d="M12 4L8 8"></path>
      <path d="M4 20h16"></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'arrow'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="m14 18l-1.4-1.45L16.15 13H4v-2h12.15L12.6 7.45L14 6l6 6l-6 6Z"
    />
  </svg>

  <svg
    v-else-if="name === 'task-completed'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32"
  >
    <path
      d="M22 27.18l-2.59-2.59L18 26l4 4l8-8l-1.41-1.41L22 27.18z"
      fill="currentColor"
    ></path>
    <path
      d="M25 5h-3V4a2.006 2.006 0 0 0-2-2h-8a2.006 2.006 0 0 0-2 2v1H7a2.006 2.006 0 0 0-2 2v21a2.006 2.006 0 0 0 2 2h9v-2H7V7h3v3h12V7h3v11h2V7a2.006 2.006 0 0 0-2-2zm-5 3h-8V4h8z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'warning'"
    stroke="currentColor"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
    />
  </svg>

  <svg
    v-else-if="name === 'check'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
  >
    <path
      d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248s248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200c0 110.532-89.451 200-200 200c-110.532 0-200-89.451-200-200c0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'check-circle-fill'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5l1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'container'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32"
  >
    <path
      d="M17 13V6H8v16h16v-9zm-7-5h5v5h-5zm0 7h5v5h-5zm12 5h-5v-5h5z"
      fill="currentColor"
    ></path>
    <path d="M28 11h-9V2h9zm-7-2h5V4h-5z" fill="currentColor"></path>
    <path
      d="M28 20h-2v2h2v6H4v-6h2v-2H4a2.002 2.002 0 0 0-2 2v6a2.002 2.002 0 0 0 2 2h24a2.002 2.002 0 0 0 2-2v-6a2.002 2.002 0 0 0-2-2z"
      fill="currentColor"
    ></path>
    <circle cx="7" cy="25" r="1" fill="currentColor"></circle>
  </svg>
  <svg
    v-else-if="name === 'print'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 20 20"
  >
    <g fill="none">
      <path
        d="M5 4.5A1.5 1.5 0 0 1 6.5 3h7A1.5 1.5 0 0 1 15 4.5V5h.5A2.5 2.5 0 0 1 18 7.5v5a1.5 1.5 0 0 1-1.5 1.5H15v1.5a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 5 15.5V14H3.5A1.5 1.5 0 0 1 2 12.5v-5A2.5 2.5 0 0 1 4.5 5H5v-.5zm9 0a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5V5h8v-.5zm-8 7v4a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5z"
        fill="currentColor"
      ></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'spine-label'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32"
  >
    <path
      d="M3 11v2h5.59l-6.3 6.29l1.42 1.42l6.29-6.3V20h2v-9H3z"
      fill="currentColor"
    ></path>
    <path
      d="M26 13h-3v-1h-2v1h-3a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h3v1h2v-1h3a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2zm-8 4v-2h8v2z"
      fill="currentColor"
    ></path>
    <path
      d="M26 23h-3v-1h-2v1h-3a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h3v1h2v-1h3a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2zm-8 4v-2h8v2z"
      fill="currentColor"
    ></path>
    <path
      d="M26 3h-3V2h-2v1h-3a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h3v1h2V9h3a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-8 4V5h8v2z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'dpd'"
    xmlns="http://www.w3.org/2000/svg"
    version="1.0"
    viewBox="0 0 54.000000 63.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,63.000000) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="none"
    >
      <path
        d="M143 547 c-62 -34 -113 -64 -113 -67 0 -3 60 -39 133 -81 l132 -75 -3 -119 c-2 -123 -10 -148 -36 -126 -12 10 -16 39 -18 118 l-3 105 -112 63 -113 64 0 -138 0 -139 130 -76 129 -76 131 77 130 77 0 139 c0 76 -3 136 -7 134 -5 -2 -41 -23 -80 -47 -71 -41 -103 -46 -103 -16 0 8 38 36 85 63 46 26 84 50 84 53 0 8 -229 130 -242 130 -7 0 -63 -29 -124 -63z"
      />
    </g>
  </svg>

  <svg
    v-else-if="name === 'manager'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <circle cx="10" cy="8" r="4" fill="currentColor"></circle>
    <path
      d="M10.67 13.02c-.22-.01-.44-.02-.67-.02c-2.42 0-4.68.67-6.61 1.82c-.88.52-1.39 1.5-1.39 2.53V20h9.26a6.963 6.963 0 0 1-.59-6.98zM20.75 16c0-.22-.03-.42-.06-.63l1.14-1.01l-1-1.73l-1.45.49c-.32-.27-.68-.48-1.08-.63L18 11h-2l-.3 1.49c-.4.15-.76.36-1.08.63l-1.45-.49l-1 1.73l1.14 1.01c-.03.21-.06.41-.06.63s.03.42.06.63l-1.14 1.01l1 1.73l1.45-.49c.32.27.68.48 1.08.63L16 21h2l.3-1.49c.4-.15.76-.36 1.08-.63l1.45.49l1-1.73l-1.14-1.01c.03-.21.06-.41.06-.63zM17 18c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'inventory'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32"
  >
    <path
      d="M9 12v-2H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-9h-2v9H4V12"
      fill="currentColor"
    ></path>
    <path
      d="M22 12h-8V4h8zM12 4v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2z"
      fill="currentColor"
    ></path>
    <path
      d="M14 18v4h-4v-4h4m-6 0v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2z"
      fill="currentColor"
    ></path>
    <path
      d="M28 17v2h-2v-2h2m-4-1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'paper'"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    enable-background="new 0 0 512 512"
    xml:space="preserve"
  >
    <g>
      <path
        d="M464,64H192c-8.8,0-16,7.7-16,16.5V112H74c-23.1,0-42,18.9-42,42v207.5c0,47.6,39,86.5,86,86.5h279.7
		c45.1,0,82.3-36.9,82.3-82V80C480,71.2,472.8,64,464,64z M176,144v192h-42V163.2c0-6.8-0.8-13.3-3.3-19.2H176z M159,399.4
		C148,410,133.2,416,118.5,416c-14.5,0-28.1-5.7-38.5-16c-10.3-10.3-16-24-16-38.5V163.2c0-10.6,8.4-19.2,19-19.2s19,8.6,19,19.2
		V352c0,8.8,7.2,16,16,16h57.5C174,379.6,168.3,390.6,159,399.4z M448,366c0,13.3-5.4,25.8-14.9,35.3c-9.5,9.5-22.2,14.7-35.4,14.7
		H187.3c12.8-14.9,20.7-33.9,20.7-54.5V112V97h240V366z"
      ></path>
      <rect x="248" y="136" width="160" height="56"></rect>
      <rect x="248" y="224" width="160" height="32"></rect>
      <rect x="248" y="288" width="160" height="32"></rect>
      <path
        d="M408,352H248c0,0,0,32-8,32c7,0,138.6,0,148.7,0C408,384,408,363,408,352z"
      ></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'theme-dark'"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.0647 5.43757C19.3421 5.43757 19.567 5.21271 19.567 4.93534C19.567 4.65796 19.3421 4.43311 19.0647 4.43311C18.7874 4.43311 18.5625 4.65796 18.5625 4.93534C18.5625 5.21271 18.7874 5.43757 19.0647 5.43757Z"
      fill="currentColor"
    ></path>
    <path
      d="M20.0692 9.48884C20.3466 9.48884 20.5714 9.26398 20.5714 8.98661C20.5714 8.70923 20.3466 8.48438 20.0692 8.48438C19.7918 8.48438 19.567 8.70923 19.567 8.98661C19.567 9.26398 19.7918 9.48884 20.0692 9.48884Z"
      fill="currentColor"
    ></path>
    <path
      d="M12.0335 20.5714C15.6943 20.5714 18.9426 18.2053 20.1168 14.7338C20.1884 14.5225 20.1114 14.289 19.9284 14.161C19.746 14.034 19.5003 14.0418 19.3257 14.1821C18.2432 15.0546 16.9371 15.5156 15.5491 15.5156C12.2257 15.5156 9.48884 12.8122 9.48884 9.48886C9.48884 7.41079 10.5773 5.47137 12.3449 4.35752C12.5342 4.23832 12.6 4.00733 12.5377 3.79251C12.4759 3.57768 12.2571 3.42859 12.0335 3.42859C7.32556 3.42859 3.42857 7.29209 3.42857 12C3.42857 16.7079 7.32556 20.5714 12.0335 20.5714Z"
      fill="currentColor"
    ></path>
    <path
      d="M13.0379 7.47998C13.8688 7.47998 14.5446 8.15585 14.5446 8.98668C14.5446 9.26428 14.7693 9.48891 15.0469 9.48891C15.3245 9.48891 15.5491 9.26428 15.5491 8.98668C15.5491 8.15585 16.225 7.47998 17.0558 7.47998C17.3334 7.47998 17.558 7.25535 17.558 6.97775C17.558 6.70015 17.3334 6.47552 17.0558 6.47552C16.225 6.47552 15.5491 5.76616 15.5491 4.93534C15.5491 4.65774 15.3245 4.43311 15.0469 4.43311C14.7693 4.43311 14.5446 4.65774 14.5446 4.93534C14.5446 5.76616 13.8688 6.47552 13.0379 6.47552C12.7603 6.47552 12.5357 6.70015 12.5357 6.97775C12.5357 7.25535 12.7603 7.47998 13.0379 7.47998Z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'theme-light'"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9905 5.62598C10.7293 5.62574 9.49646 5.9995 8.44775 6.69997C7.39903 7.40045 6.58159 8.39619 6.09881 9.56126C5.61603 10.7263 5.48958 12.0084 5.73547 13.2453C5.98135 14.4823 6.58852 15.6185 7.48019 16.5104C8.37186 17.4022 9.50798 18.0096 10.7449 18.2557C11.9818 18.5019 13.2639 18.3757 14.429 17.8931C15.5942 17.4106 16.5901 16.5933 17.2908 15.5448C17.9915 14.4962 18.3655 13.2634 18.3655 12.0023C18.3637 10.3119 17.6916 8.69129 16.4964 7.49593C15.3013 6.30056 13.6808 5.62806 11.9905 5.62598Z"
      fill="currentColor"
    ></path>
    <path
      d="M22.1258 10.8771H20.627C20.3286 10.8771 20.0424 10.9956 19.8314 11.2066C19.6204 11.4176 19.5018 11.7038 19.5018 12.0023C19.5018 12.3007 19.6204 12.5869 19.8314 12.7979C20.0424 13.0089 20.3286 13.1274 20.627 13.1274H22.1258C22.4242 13.1274 22.7104 13.0089 22.9214 12.7979C23.1324 12.5869 23.2509 12.3007 23.2509 12.0023C23.2509 11.7038 23.1324 11.4176 22.9214 11.2066C22.7104 10.9956 22.4242 10.8771 22.1258 10.8771Z"
      fill="currentColor"
    ></path>
    <path
      d="M11.9905 19.4995C11.6923 19.5 11.4064 19.6187 11.1956 19.8296C10.9848 20.0405 10.8663 20.3265 10.866 20.6247V22.1249C10.866 22.4231 10.9845 22.7091 11.1953 22.9199C11.4062 23.1308 11.6922 23.2492 11.9904 23.2492C12.2886 23.2492 12.5746 23.1308 12.7854 22.9199C12.9963 22.7091 13.1147 22.4231 13.1147 22.1249V20.6247C13.1145 20.3265 12.996 20.0406 12.7853 19.8296C12.5745 19.6187 12.2887 19.5 11.9905 19.4995Z"
      fill="currentColor"
    ></path>
    <path
      d="M4.49743 12.0023C4.49718 11.704 4.37865 11.4181 4.16785 11.2072C3.95705 10.9962 3.67119 10.8775 3.37298 10.8771H1.87445C1.57603 10.8771 1.28984 10.9956 1.07883 11.2066C0.867812 11.4176 0.749266 11.7038 0.749266 12.0023C0.749266 12.3007 0.867812 12.5869 1.07883 12.7979C1.28984 13.0089 1.57603 13.1274 1.87445 13.1274H3.37299C3.6712 13.127 3.95706 13.0083 4.16785 12.7973C4.37865 12.5864 4.49718 12.3005 4.49743 12.0023Z"
      fill="currentColor"
    ></path>
    <path
      d="M11.9905 4.50058C12.2887 4.50012 12.5745 4.38141 12.7853 4.17048C12.9961 3.95954 13.1147 3.67361 13.1149 3.3754V1.87521C13.1149 1.57701 12.9965 1.29103 12.7856 1.08017C12.5748 0.869313 12.2888 0.750854 11.9906 0.750854C11.6924 0.750854 11.4064 0.869313 11.1955 1.08017C10.9847 1.29103 10.8662 1.57701 10.8662 1.87521V3.3754C10.8664 3.67359 10.9849 3.95952 11.1957 4.17046C11.4065 4.3814 11.6923 4.50012 11.9905 4.50058Z"
      fill="currentColor"
    ></path>
    <path
      d="M18.8857 6.6972L19.9465 5.63642C20.0512 5.53209 20.1343 5.40813 20.1911 5.27163C20.2479 5.13513 20.2772 4.98877 20.2774 4.84093C20.2775 4.69309 20.2485 4.54667 20.192 4.41006C20.1355 4.27344 20.0526 4.14932 19.948 4.04478C19.8435 3.94024 19.7194 3.85734 19.5828 3.80083C19.4462 3.74432 19.2997 3.71531 19.1519 3.71545C19.0041 3.7156 18.8577 3.7449 18.7212 3.80167C18.5847 3.85845 18.4607 3.94159 18.3564 4.04633L17.2956 5.10714C17.1909 5.21147 17.1077 5.33543 17.0509 5.47194C16.9942 5.60844 16.9649 5.7548 16.9647 5.90264C16.9646 6.05048 16.9936 6.19689 17.0501 6.33351C17.1066 6.47012 17.1895 6.59425 17.294 6.69878C17.3986 6.80332 17.5227 6.88621 17.6593 6.94272C17.7959 6.99923 17.9424 7.02824 18.0902 7.02809C18.238 7.02795 18.3844 6.99865 18.5209 6.94187C18.6574 6.88509 18.7814 6.80195 18.8857 6.6972Z"
      fill="currentColor"
    ></path>
    <path
      d="M18.8855 17.3073C18.7812 17.2026 18.6572 17.1195 18.5207 17.0627C18.3843 17.006 18.2379 16.9767 18.0901 16.9766C17.9423 16.9764 17.7959 17.0055 17.6593 17.062C17.5227 17.1185 17.3986 17.2014 17.2941 17.3059C17.1895 17.4104 17.1067 17.5345 17.0501 17.6711C16.9936 17.8077 16.9646 17.9541 16.9648 18.1019C16.9649 18.2497 16.9942 18.3961 17.0509 18.5326C17.1077 18.6691 17.1908 18.793 17.2955 18.8974L18.3563 19.9582C18.4606 20.0629 18.5846 20.146 18.721 20.2027C18.8575 20.2595 19.0039 20.2887 19.1517 20.2889C19.2995 20.289 19.4459 20.26 19.5825 20.2035C19.7191 20.147 19.8432 20.0641 19.9477 19.9595C20.0523 19.855 20.1351 19.7309 20.1916 19.5943C20.2482 19.4577 20.2772 19.3113 20.277 19.1635C20.2769 19.0157 20.2476 18.8694 20.1909 18.7329C20.1341 18.5964 20.051 18.4724 19.9463 18.3681L18.8855 17.3073Z"
      fill="currentColor"
    ></path>
    <path
      d="M5.09528 17.3072L4.0345 18.368C3.92972 18.4723 3.84655 18.5963 3.78974 18.7328C3.73294 18.8693 3.70362 19.0156 3.70346 19.1635C3.7033 19.3114 3.7323 19.4578 3.78881 19.5944C3.84532 19.7311 3.92822 19.8552 4.03277 19.9598C4.13732 20.0643 4.26147 20.1472 4.3981 20.2037C4.53473 20.2602 4.68117 20.2892 4.82902 20.2891C4.97688 20.2889 5.12325 20.2596 5.25976 20.2028C5.39627 20.146 5.52024 20.0628 5.62456 19.958L6.68536 18.8973C6.79007 18.7929 6.87318 18.6689 6.92993 18.5325C6.98667 18.396 7.01595 18.2496 7.01608 18.1018C7.01621 17.954 6.98719 17.8076 6.93068 17.671C6.87417 17.5344 6.79129 17.4103 6.68676 17.3058C6.58224 17.2012 6.45813 17.1183 6.32153 17.0618C6.18494 17.0053 6.03855 16.9763 5.89073 16.9764C5.74291 16.9766 5.59657 17.0058 5.46007 17.0626C5.32358 17.1193 5.19962 17.2024 5.09528 17.3072Z"
      fill="currentColor"
    ></path>
    <path
      d="M5.09541 6.69715C5.19979 6.8017 5.32374 6.88466 5.4602 6.94128C5.59665 6.9979 5.74292 7.02708 5.89065 7.02714C6.03839 7.0272 6.18469 6.99815 6.32119 6.94164C6.45769 6.88514 6.58171 6.80228 6.68618 6.69782C6.79064 6.59336 6.87349 6.46933 6.93 6.33283C6.9865 6.19633 7.01556 6.05003 7.01549 5.9023C7.01543 5.75457 6.98625 5.60829 6.92963 5.47184C6.87301 5.33539 6.79005 5.21143 6.6855 5.10706L5.6247 4.04626C5.5204 3.94137 5.39643 3.8581 5.25989 3.80121C5.12335 3.74432 4.97692 3.71493 4.82901 3.71472C4.68109 3.71452 4.53458 3.7435 4.39789 3.80001C4.26119 3.85652 4.13699 3.93945 4.03239 4.04404C3.9278 4.14864 3.84487 4.27284 3.78836 4.40954C3.73185 4.54624 3.70287 4.69274 3.70308 4.84066C3.70329 4.98858 3.73268 5.135 3.78957 5.27154C3.84646 5.40808 3.92974 5.53205 4.03462 5.63635L5.09541 6.69715Z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'dashboard'"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="2" y="2" width="9" height="9" rx="2" fill="currentColor"></rect>
    <rect
      opacity="0.3"
      x="13"
      y="2"
      width="9"
      height="9"
      rx="2"
      fill="currentColor"
    ></rect>
    <rect
      opacity="0.3"
      x="13"
      y="13"
      width="9"
      height="9"
      rx="2"
      fill="currentColor"
    ></rect>
    <rect
      opacity="0.3"
      x="2"
      y="13"
      width="9"
      height="9"
      rx="2"
      fill="currentColor"
    ></rect>
  </svg>

  <svg
    v-else-if="name === 'profile'"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 256 256"
  >
    <path
      fill="currentColor"
      d="M152 136a24 24 0 1 1-24-24a24.1 24.1 0 0 1 24 24Zm64-96v176a16 16 0 0 1-16 16H56a16 16 0 0 1-16-16V40a16 16 0 0 1 16-16h144a16 16 0 0 1 16 16ZM88 56a8 8 0 0 0 8 8h64a8 8 0 0 0 0-16H96a8 8 0 0 0-8 8Zm94.4 131.2a67.8 67.8 0 0 0-27.4-21.7a40 40 0 1 0-54 0a67.8 67.8 0 0 0-27.4 21.7a8 8 0 0 0 1.6 11.2A7.7 7.7 0 0 0 80 200a8 8 0 0 0 6.4-3.2a52 52 0 0 1 83.2 0a8.1 8.1 0 0 0 11.2 1.6a8 8 0 0 0 1.6-11.2Z"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'profile-fill'"
    viewBox="0 0 26 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.8254 27.3337H4.17203C3.1536 27.3337 2.17688 26.9291 1.45674 26.2089C0.736602 25.4888 0.332031 24.5121 0.332031 23.4937V4.50699C0.332031 3.48856 0.736602 2.51184 1.45674 1.7917C2.17688 1.07156 3.1536 0.666992 4.17203 0.666992H17.8254C18.8438 0.666992 19.8205 1.07156 20.5407 1.7917C21.2608 2.51184 21.6654 3.48856 21.6654 4.50699V23.4937C21.6654 24.5121 21.2608 25.4888 20.5407 26.2089C19.8205 26.9291 18.8438 27.3337 17.8254 27.3337ZM10.9987 7.33366C10.4713 7.33366 9.95571 7.49006 9.51718 7.78307C9.07865 8.07609 8.73685 8.49257 8.53502 8.97984C8.33319 9.46711 8.28038 10.0033 8.38327 10.5206C8.48616 11.0378 8.74014 11.513 9.11308 11.8859C9.48602 12.2589 9.96117 12.5129 10.4785 12.6158C10.9957 12.7186 11.5319 12.6658 12.0192 12.464C12.5065 12.2622 12.9229 11.9204 13.216 11.4818C13.509 11.0433 13.6654 10.5277 13.6654 10.0003C13.6654 9.29308 13.3844 8.6148 12.8843 8.11471C12.3842 7.61461 11.7059 7.33366 10.9987 7.33366ZM15.3587 19.3337C15.5794 19.347 15.8 19.3052 16.0005 19.2121C16.2011 19.1189 16.3753 18.9774 16.5076 18.8002C16.6398 18.623 16.7259 18.4157 16.7581 18.1969C16.7903 17.9781 16.7676 17.7548 16.692 17.547C16.2027 16.4571 15.3998 15.5378 14.3858 14.9061C13.3718 14.2744 12.1926 13.9591 10.9987 14.0003C9.81328 13.9677 8.64459 14.2856 7.63898 14.9141C6.63337 15.5426 5.83553 16.4538 5.34537 17.5337C4.9987 18.4003 5.70536 19.3337 7.38536 19.3337H15.3587ZM24.332 12.667H22.9987V18.0003H24.332C24.6857 18.0003 25.0248 17.8598 25.2748 17.6098C25.5249 17.3598 25.6654 17.0206 25.6654 16.667V14.0003C25.6654 13.6467 25.5249 13.3076 25.2748 13.0575C25.0248 12.8075 24.6857 12.667 24.332 12.667ZM24.332 4.66699H22.9987V10.0003H24.332C24.6857 10.0003 25.0248 9.85985 25.2748 9.6098C25.5249 9.35975 25.6654 9.02061 25.6654 8.66699V6.00033C25.6654 5.6467 25.5249 5.30756 25.2748 5.05752C25.0248 4.80747 24.6857 4.66699 24.332 4.66699Z"
      fill="currentColor"
    />
  </svg>

  <svg
    v-else-if="name === 'users'"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 256 256"
    style="transform: rotate(360deg)"
  >
    <path
      fill="currentColor"
      d="M64 140a7.9 7.9 0 0 1-8 8H12a8.2 8.2 0 0 1-7.2-4.4a8.2 8.2 0 0 1 .8-8.4A67.8 67.8 0 0 1 33 113.5a40 40 0 1 1 66.3-37a8.1 8.1 0 0 1-3.8 8.4a64.3 64.3 0 0 0-27.8 33.8A61.6 61.6 0 0 0 64 140Zm186.4-4.8a67.8 67.8 0 0 0-27.4-21.7a40 40 0 1 0-66.3-37a8.1 8.1 0 0 0 3.8 8.4a64 64 0 0 1 27.8 33.8A61.6 61.6 0 0 1 192 140a7.9 7.9 0 0 0 8 8h44a8 8 0 0 0 6.4-12.8Zm-93.2 42.9a48 48 0 1 0-58.4 0a72.1 72.1 0 0 0-35.6 34.4a7.8 7.8 0 0 0 .5 7.7a7.8 7.8 0 0 0 6.7 3.8h115.2a7.8 7.8 0 0 0 6.7-3.8a7.8 7.8 0 0 0 .5-7.7a72.1 72.1 0 0 0-35.6-34.4Z"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'payment'"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 20C6 20.6 5.6 21 5 21C4.4 21 4 20.6 4 20H6ZM18 20C18 20.6 18.4 21 19 21C19.6 21 20 20.6 20 20H18Z"
      fill="currentColor"
    />
    <path
      opacity="0.3"
      d="M21 20H3C2.4 20 2 19.6 2 19V3C2 2.4 2.4 2 3 2H21C21.6 2 22 2.4 22 3V19C22 19.6 21.6 20 21 20ZM12 10H10.7C10.5 9.7 10.3 9.50005 10 9.30005V8C10 7.4 9.6 7 9 7C8.4 7 8 7.4 8 8V9.30005C7.7 9.50005 7.5 9.7 7.3 10H6C5.4 10 5 10.4 5 11C5 11.6 5.4 12 6 12H7.3C7.5 12.3 7.7 12.5 8 12.7V14C8 14.6 8.4 15 9 15C9.6 15 10 14.6 10 14V12.7C10.3 12.5 10.5 12.3 10.7 12H12C12.6 12 13 11.6 13 11C13 10.4 12.6 10 12 10Z"
      fill="currentColor"
    />
    <path
      d="M18.5 11C18.5 10.2 17.8 9.5 17 9.5C16.2 9.5 15.5 10.2 15.5 11C15.5 11.4 15.7 11.8 16 12.1V13C16 13.6 16.4 14 17 14C17.6 14 18 13.6 18 13V12.1C18.3 11.8 18.5 11.4 18.5 11Z"
      fill="currentColor"
    />
  </svg>

  <svg
    v-else-if="name === 'exchange'"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.3"
      d="M12.5 22C11.9 22 11.5 21.6 11.5 21V3C11.5 2.4 11.9 2 12.5 2C13.1 2 13.5 2.4 13.5 3V21C13.5 21.6 13.1 22 12.5 22Z"
      fill="currentColor"
    />
    <path
      d="M17.8 14.7C17.8 15.5 17.6 16.3 17.2 16.9C16.8 17.6 16.2 18.1 15.3 18.4C14.5 18.8 13.5 19 12.4 19C11.1 19 10 18.7 9.10001 18.2C8.50001 17.8 8.00001 17.4 7.60001 16.7C7.20001 16.1 7 15.5 7 14.9C7 14.6 7.09999 14.3 7.29999 14C7.49999 13.8 7.80001 13.6 8.20001 13.6C8.50001 13.6 8.69999 13.7 8.89999 13.9C9.09999 14.1 9.29999 14.4 9.39999 14.7C9.59999 15.1 9.8 15.5 10 15.8C10.2 16.1 10.5 16.3 10.8 16.5C11.2 16.7 11.6 16.8 12.2 16.8C13 16.8 13.7 16.6 14.2 16.2C14.7 15.8 15 15.3 15 14.8C15 14.4 14.9 14 14.6 13.7C14.3 13.4 14 13.2 13.5 13.1C13.1 13 12.5 12.8 11.8 12.6C10.8 12.4 9.99999 12.1 9.39999 11.8C8.69999 11.5 8.19999 11.1 7.79999 10.6C7.39999 10.1 7.20001 9.39998 7.20001 8.59998C7.20001 7.89998 7.39999 7.19998 7.79999 6.59998C8.19999 5.99998 8.80001 5.60005 9.60001 5.30005C10.4 5.00005 11.3 4.80005 12.3 4.80005C13.1 4.80005 13.8 4.89998 14.5 5.09998C15.1 5.29998 15.6 5.60002 16 5.90002C16.4 6.20002 16.7 6.6 16.9 7C17.1 7.4 17.2 7.69998 17.2 8.09998C17.2 8.39998 17.1 8.7 16.9 9C16.7 9.3 16.4 9.40002 16 9.40002C15.7 9.40002 15.4 9.29995 15.3 9.19995C15.2 9.09995 15 8.80002 14.8 8.40002C14.6 7.90002 14.3 7.49995 13.9 7.19995C13.5 6.89995 13 6.80005 12.2 6.80005C11.5 6.80005 10.9 7.00005 10.5 7.30005C10.1 7.60005 9.79999 8.00002 9.79999 8.40002C9.79999 8.70002 9.9 8.89998 10 9.09998C10.1 9.29998 10.4 9.49998 10.6 9.59998C10.8 9.69998 11.1 9.90002 11.4 9.90002C11.7 10 12.1 10.1 12.7 10.3C13.5 10.5 14.2 10.7 14.8 10.9C15.4 11.1 15.9 11.4 16.4 11.7C16.8 12 17.2 12.4 17.4 12.9C17.6 13.4 17.8 14 17.8 14.7Z"
      fill="currentColor"
    />
  </svg>

  <svg
    v-else-if="name === 'humburger'"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="16"
      height="2"
      rx="1"
      transform="matrix(-1 0 0 1 16 0)"
      fill="currentColor"
    />
    <rect
      width="16"
      height="2"
      rx="1"
      transform="matrix(-1 0 0 1 16 6)"
      fill="currentColor"
    />
    <rect
      width="16"
      height="2"
      rx="1"
      transform="matrix(-1 0 0 1 16 12)"
      fill="currentColor"
    />
  </svg>

  <svg
    v-else-if="name === 'double-arrow'"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      d="M14.2657 11.4343L18.45 7.25C18.8642 6.83579 18.8642 6.16421 18.45 5.75C18.0358 5.33579 17.3642 5.33579 16.95 5.75L11.4071 11.2929C11.0166 11.6834 11.0166 12.3166 11.4071 12.7071L16.95 18.25C17.3642 18.6642 18.0358 18.6642 18.45 18.25C18.8642 17.8358 18.8642 17.1642 18.45 16.75L14.2657 12.5657C13.9533 12.2533 13.9533 11.7467 14.2657 11.4343Z"
      fill="currentColor"
    />
    <path
      d="M8.2657 11.4343L12.45 7.25C12.8642 6.83579 12.8642 6.16421 12.45 5.75C12.0358 5.33579 11.3642 5.33579 10.95 5.75L5.40712 11.2929C5.01659 11.6834 5.01659 12.3166 5.40712 12.7071L10.95 18.25C11.3642 18.6642 12.0358 18.6642 12.45 18.25C12.8642 17.8358 12.8642 17.1642 12.45 16.75L8.2657 12.5657C7.95328 12.2533 7.95328 11.7467 8.2657 11.4343Z"
      fill="currentColor"
    />
  </svg>

  <svg
    v-else-if="name === 'information-circle'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
  >
    <path
      d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42s-42-18.804-42-42s18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'check-circle'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5l1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'exclamation-trianble'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 576 512"
  >
    <path
      d="M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46s46-20.595 46-46s-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'close'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <path
      d="M18.3 5.71a.996.996 0 0 0-1.41 0L12 10.59L7.11 5.7A.996.996 0 1 0 5.7 7.11L10.59 12L5.7 16.89a.996.996 0 1 0 1.41 1.41L12 13.41l4.89 4.89a.996.996 0 1 0 1.41-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'close-2'"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      opacity="0.5"
      x="6"
      y="17.3137"
      width="16"
      height="2"
      rx="1"
      transform="rotate(-45 6 17.3137)"
      fill="currentColor"
    />
    <rect
      x="7.41422"
      y="6"
      width="16"
      height="2"
      rx="1"
      transform="rotate(45 7.41422 6)"
      fill="currentColor"
    />
  </svg>

  <svg
    v-else-if="name === 'close-circle'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32"
  >
    <path
      d="M16 2C8.2 2 2 8.2 2 16s6.2 14 14 14s14-6.2 14-14S23.8 2 16 2zm5.4 21L16 17.6L10.6 23L9 21.4l5.4-5.4L9 10.6L10.6 9l5.4 5.4L21.4 9l1.6 1.6l-5.4 5.4l5.4 5.4l-1.6 1.6z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'caret'"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M12 16a1 1 0 0 1-.64-.23l-6-5a1 1 0 1 1 1.28-1.54L12 13.71l5.36-4.32a1 1 0 0 1 1.41.15a1 1 0 0 1-.14 1.46l-6 4.83A1 1 0 0 1 12 16Z"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'dot'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32"
  >
    <circle cx="16" cy="16" r="8" fill="currentColor"></circle>
  </svg>

  <svg
    v-else-if="name === 'withdrawal'"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.3"
      d="M3.20001 5.91897L16.9 3.01895C17.4 2.91895 18 3.219 18.1 3.819L19.2 9.01895L3.20001 5.91897Z"
      fill="currentColor"
    ></path>
    <path
      opacity="0.3"
      d="M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21C21.6 10.9189 22 11.3189 22 11.9189V15.9189C22 16.5189 21.6 16.9189 21 16.9189H16C14.3 16.9189 13 15.6189 13 13.9189ZM16 12.4189C15.2 12.4189 14.5 13.1189 14.5 13.9189C14.5 14.7189 15.2 15.4189 16 15.4189C16.8 15.4189 17.5 14.7189 17.5 13.9189C17.5 13.1189 16.8 12.4189 16 12.4189Z"
      fill="currentColor"
    ></path>
    <path
      d="M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21V7.91895C21 6.81895 20.1 5.91895 19 5.91895H3C2.4 5.91895 2 6.31895 2 6.91895V20.9189C2 21.5189 2.4 21.9189 3 21.9189H19C20.1 21.9189 21 21.0189 21 19.9189V16.9189H16C14.3 16.9189 13 15.6189 13 13.9189Z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'trading'"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.3"
      d="M14 3V21H10V3C10 2.4 10.4 2 11 2H13C13.6 2 14 2.4 14 3ZM7 14H5C4.4 14 4 14.4 4 15V21H8V15C8 14.4 7.6 14 7 14Z"
      fill="currentColor"
    ></path>
    <path
      d="M21 20H20V8C20 7.4 19.6 7 19 7H17C16.4 7 16 7.4 16 8V20H3C2.4 20 2 20.4 2 21C2 21.6 2.4 22 3 22H21C21.6 22 22 21.6 22 21C22 20.4 21.6 20 21 20Z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'level'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32"
  >
    <path d="M14 8h-4V4H8v4H4v2h4v4h2v-4h4V8z" fill="currentColor"></path>
    <path d="M4 19h10v2H4z" fill="currentColor"></path>
    <path d="M4 24h10v2H4z" fill="currentColor"></path>
    <path d="M18 8h10v2H18z" fill="currentColor"></path>
    <path
      d="M24.41 22L28 18.41L26.59 17L23 20.59L19.41 17L18 18.41L21.59 22L18 25.59L19.41 27L23 23.41L26.59 27L28 25.59L24.41 22z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'chart'"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="6" width="16" height="3" rx="1.5" fill="currentColor"></rect>
    <rect
      opacity="0.3"
      y="12"
      width="8"
      height="3"
      rx="1.5"
      fill="currentColor"
    ></rect>
    <rect
      opacity="0.3"
      width="12"
      height="3"
      rx="1.5"
      fill="currentColor"
    ></rect>
  </svg>

  <svg
    v-else-if="name === 'chart-2'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 256 256"
  >
    <path
      fill="currentColor"
      d="M232 208a8 8 0 0 1-8 8H32a8 8 0 0 1 0-16h8v-64a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v64h16V88a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8v112h16V40a8 8 0 0 1 8-8h40a8 8 0 0 1 8 8v160h8a8 8 0 0 1 8 8Z"
    />
  </svg>

  <svg
    v-else-if="name === 'chevron-down'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M19 9l-7 7-7-7"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'google'"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path
      d="M15.545 6.558a9.42 9.42 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.689 7.689 0 0 1 5.352 2.082l-2.284 2.284A4.347 4.347 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.792 4.792 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.702 3.702 0 0 0 1.599-2.431H8v-3.08h7.545z"
    />
  </svg>

  <svg
    v-else-if="name === 'percentage'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <g
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="17" cy="17" r="1"></circle>
      <circle cx="7" cy="7" r="1"></circle>
      <path d="M6 18L18 6"></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'bank'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 20 20"
  >
    <g fill="none">
      <path
        d="M10 5.874a.833.833 0 1 0 0-1.667a.833.833 0 0 0 0 1.667zm6 7.466V8h.092c.893 0 1.26-1.148.53-1.665l-5.85-4.152a1.333 1.333 0 0 0-1.544 0L3.376 6.335c-.728.517-.363 1.664.53 1.664H4v5.34c-.601.386-1 1.06-1 1.827v1.333a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-1.333c0-.767-.398-1.441-1-1.826zM9.806 2.999a.333.333 0 0 1 .385 0l5.639 4H4.168l5.639-4zm5.192 5v5.006a2.19 2.19 0 0 0-.166-.006h-1.834V8h2zM5 13.005V8h2v5H5.166c-.056 0-.112.002-.167.006zm.167.994h9.667c.644 0 1.166.522 1.166 1.167v.833H4v-.833c0-.645.523-1.167 1.167-1.167zm4.333-1H8V8h1.5v5zm1 0V8H12v5h-1.5z"
        fill="currentColor"
      ></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'bank-2'"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 19.725V18.725C20 18.125 19.6 17.725 19 17.725H5C4.4 17.725 4 18.125 4 18.725V19.725H3C2.4 19.725 2 20.125 2 20.725V21.725H22V20.725C22 20.125 21.6 19.725 21 19.725H20Z"
      fill="currentColor"
    />
    <path
      opacity="0.3"
      d="M22 6.725V7.725C22 8.325 21.6 8.725 21 8.725H18C18.6 8.725 19 9.125 19 9.725C19 10.325 18.6 10.725 18 10.725V15.725C18.6 15.725 19 16.125 19 16.725V17.725H15V16.725C15 16.125 15.4 15.725 16 15.725V10.725C15.4 10.725 15 10.325 15 9.725C15 9.125 15.4 8.725 16 8.725H13C13.6 8.725 14 9.125 14 9.725C14 10.325 13.6 10.725 13 10.725V15.725C13.6 15.725 14 16.125 14 16.725V17.725H10V16.725C10 16.125 10.4 15.725 11 15.725V10.725C10.4 10.725 10 10.325 10 9.725C10 9.125 10.4 8.725 11 8.725H8C8.6 8.725 9 9.125 9 9.725C9 10.325 8.6 10.725 8 10.725V15.725C8.6 15.725 9 16.125 9 16.725V17.725H5V16.725C5 16.125 5.4 15.725 6 15.725V10.725C5.4 10.725 5 10.325 5 9.725C5 9.125 5.4 8.725 6 8.725H3C2.4 8.725 2 8.325 2 7.725V6.725L11 2.225C11.6 1.925 12.4 1.925 13.1 2.225L22 6.725ZM12 3.725C11.2 3.725 10.5 4.425 10.5 5.225C10.5 6.025 11.2 6.725 12 6.725C12.8 6.725 13.5 6.025 13.5 5.225C13.5 4.425 12.8 3.725 12 3.725Z"
      fill="currentColor"
    />
  </svg>

  <svg
    v-else-if="name === 'deposit'"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.3"
      d="M8.9 21L7.19999 22.6999C6.79999 23.0999 6.2 23.0999 5.8 22.6999L4.1 21H8.9ZM4 16.0999L2.3 17.8C1.9 18.2 1.9 18.7999 2.3 19.1999L4 20.9V16.0999ZM19.3 9.1999L15.8 5.6999C15.4 5.2999 14.8 5.2999 14.4 5.6999L9 11.0999V21L19.3 10.6999C19.7 10.2999 19.7 9.5999 19.3 9.1999Z"
      fill="currentColor"
    />
    <path
      d="M21 15V20C21 20.6 20.6 21 20 21H11.8L18.8 14H20C20.6 14 21 14.4 21 15ZM10 21V4C10 3.4 9.6 3 9 3H4C3.4 3 3 3.4 3 4V21C3 21.6 3.4 22 4 22H9C9.6 22 10 21.6 10 21ZM7.5 18.5C7.5 19.1 7.1 19.5 6.5 19.5C5.9 19.5 5.5 19.1 5.5 18.5C5.5 17.9 5.9 17.5 6.5 17.5C7.1 17.5 7.5 17.9 7.5 18.5Z"
      fill="currentColor"
    />
  </svg>
  <svg
    v-else-if="name === 'invest'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <path
      d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15c0-1.09 1.01-1.85 2.7-1.85c1.42 0 2.13.54 2.39 1.4c.12.4.45.7.87.7h.3c.66 0 1.13-.65.9-1.27c-.42-1.18-1.4-2.16-2.96-2.54V4.5c0-.83-.67-1.5-1.5-1.5S10 3.67 10 4.5v.66c-1.94.42-3.5 1.68-3.5 3.61c0 2.31 1.91 3.46 4.7 4.13c2.5.6 3 1.48 3 2.41c0 .69-.49 1.79-2.7 1.79c-1.65 0-2.5-.59-2.83-1.43c-.15-.39-.49-.67-.9-.67h-.28c-.67 0-1.14.68-.89 1.3c.57 1.39 1.9 2.21 3.4 2.53v.67c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-.65c1.95-.37 3.5-1.5 3.5-3.55c0-2.84-2.43-3.81-4.7-4.4z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'calander'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <path
      d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2zM9 14H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm-8 4H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'daily'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <path
      d="M5 17.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.67 1.5 1.5 1.5zM9 13c.55 0 1-.45 1-1s-.45-1-1-1s-1 .45-1 1s.45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1s-1 .45-1 1s.45 1 1 1zM3 21h18v-2H3v2zM5 9.5c.83 0 1.5-.67 1.5-1.5S5.83 6.5 5 6.5S3.5 7.17 3.5 8S4.17 9.5 5 9.5zm0 4c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.67 1.5 1.5 1.5zM9 17c.55 0 1-.45 1-1s-.45-1-1-1s-1 .45-1 1s.45 1 1 1zm8-.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5s-.5.22-.5.5s.22.5.5.5zM3 3v2h18V3H3zm14 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5s-.5.22-.5.5s.22.5.5.5zm0 4c.28 0 .5-.22.5-.5s-.22-.5-.5-.5s-.5.22-.5.5s.22.5.5.5zM13 9c.55 0 1-.45 1-1s-.45-1-1-1s-1 .45-1 1s.45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1s-1 .45-1 1s.45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1s-1 .45-1 1s.45 1 1 1z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'circle-chart'"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 5.91517C15.8 6.41517 18 8.81519 18 11.8152C18 12.5152 17.9 13.2152 17.6 13.9152L20.1 15.3152C20.6 15.6152 21.4 15.4152 21.6 14.8152C21.9 13.9152 22.1 12.9152 22.1 11.8152C22.1 7.01519 18.8 3.11521 14.3 2.01521C13.7 1.91521 13.1 2.31521 13.1 3.01521V5.91517H13Z"
      fill="currentColor"
    ></path>
    <path
      opacity="0.3"
      d="M19.1 17.0152C19.7 17.3152 19.8 18.1152 19.3 18.5152C17.5 20.5152 14.9 21.7152 12 21.7152C9.1 21.7152 6.50001 20.5152 4.70001 18.5152C4.30001 18.0152 4.39999 17.3152 4.89999 17.0152L7.39999 15.6152C8.49999 16.9152 10.2 17.8152 12 17.8152C13.8 17.8152 15.5 17.0152 16.6 15.6152L19.1 17.0152ZM6.39999 13.9151C6.19999 13.2151 6 12.5152 6 11.8152C6 8.81517 8.2 6.41515 11 5.91515V3.01519C11 2.41519 10.4 1.91519 9.79999 2.01519C5.29999 3.01519 2 7.01517 2 11.8152C2 12.8152 2.2 13.8152 2.5 14.8152C2.7 15.4152 3.4 15.7152 4 15.3152L6.39999 13.9151Z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'loading'"
    class="animate-spin"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      class="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      stroke-width="4"
    ></circle>
    <path
      class="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'investment'"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.3"
      d="M20.859 12.596L17.736 13.596L10.388 20.944C10.2915 21.0406 10.1769 21.1172 10.0508 21.1695C9.9247 21.2218 9.78953 21.2486 9.65302 21.2486C9.5165 21.2486 9.3813 21.2218 9.25519 21.1695C9.12907 21.1172 9.01449 21.0406 8.918 20.944L2.29999 14.3229C2.10543 14.1278 1.99619 13.8635 1.99619 13.588C1.99619 13.3124 2.10543 13.0481 2.29999 12.853L11.853 3.29999C11.9495 3.20341 12.0641 3.12679 12.1902 3.07452C12.3163 3.02225 12.4515 2.9953 12.588 2.9953C12.7245 2.9953 12.8597 3.02225 12.9858 3.07452C13.1119 3.12679 13.2265 3.20341 13.323 3.29999L21.199 11.176C21.3036 11.2791 21.3797 11.4075 21.4201 11.5486C21.4605 11.6898 21.4637 11.8391 21.4295 11.9819C21.3953 12.1247 21.3249 12.2562 21.2249 12.3638C21.125 12.4714 20.9989 12.5514 20.859 12.596Z"
      fill="currentColor"
    ></path>
    <path
      d="M14.8 10.184C14.7447 10.1843 14.6895 10.1796 14.635 10.1699L5.816 8.69997C5.55436 8.65634 5.32077 8.51055 5.16661 8.29469C5.01246 8.07884 4.95035 7.8106 4.99397 7.54897C5.0376 7.28733 5.18339 7.05371 5.39925 6.89955C5.6151 6.7454 5.88334 6.68332 6.14498 6.72694L14.963 8.19692C15.2112 8.23733 15.435 8.36982 15.59 8.56789C15.7449 8.76596 15.8195 9.01502 15.7989 9.26564C15.7784 9.51626 15.6642 9.75001 15.479 9.92018C15.2939 10.0904 15.0514 10.1846 14.8 10.184ZM17 18.6229C17 19.0281 17.0985 19.4272 17.287 19.7859C17.4755 20.1446 17.7484 20.4521 18.0821 20.6819C18.4158 20.9117 18.8004 21.0571 19.2027 21.1052C19.605 21.1534 20.0131 21.103 20.3916 20.9585C20.7702 20.814 21.1079 20.5797 21.3758 20.2757C21.6437 19.9716 21.8336 19.607 21.9293 19.2133C22.025 18.8195 22.0235 18.4085 21.925 18.0154C21.8266 17.6223 21.634 17.259 21.364 16.9569L19.843 15.257C19.7999 15.2085 19.7471 15.1697 19.688 15.1432C19.6289 15.1167 19.5648 15.1029 19.5 15.1029C19.4352 15.1029 19.3711 15.1167 19.312 15.1432C19.2529 15.1697 19.2001 15.2085 19.157 15.257L17.636 16.9569C17.2254 17.4146 16.9988 18.0081 17 18.6229ZM10.388 20.9409L17.736 13.5929H1.99999C1.99921 13.7291 2.02532 13.8643 2.0768 13.9904C2.12828 14.1165 2.2041 14.2311 2.29997 14.3279L8.91399 20.9409C9.01055 21.0381 9.12539 21.1152 9.25188 21.1679C9.37836 21.2205 9.51399 21.2476 9.65099 21.2476C9.78798 21.2476 9.92361 21.2205 10.0501 21.1679C10.1766 21.1152 10.2914 21.0381 10.388 20.9409Z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'circle-tick'"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      opacity="0.3"
      x="2"
      y="2"
      width="20"
      height="20"
      rx="10"
      fill="currentColor"
    />
    <path
      d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z"
      fill="currentColor"
    />
  </svg>

  <svg
    v-else-if="name === 'home'"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 256 256"
  >
    <path
      fill="currentColor"
      d="M224 115.5V208a16.1 16.1 0 0 1-8.4 14.1a15.3 15.3 0 0 1-7.6 1.9h-48a8 8 0 0 1-8-8v-48a8 8 0 0 0-8-8h-32a8 8 0 0 0-8 8v48a8 8 0 0 1-8 8H48a15.9 15.9 0 0 1-12-5.4a16.9 16.9 0 0 1-4-11v-92.1a16 16 0 0 1 5.2-11.8l80-72.7a16 16 0 0 1 21.6 0l80 72.7a16 16 0 0 1 5.2 11.8Z"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'account'"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 256 256"
  >
    <path
      fill="currentColor"
      d="M172 120a44 44 0 1 1-44-44a44 44 0 0 1 44 44Zm60 8A104 104 0 1 1 128 24a104.2 104.2 0 0 1 104 104Zm-16 0a88 88 0 1 0-153.8 58.4a81.3 81.3 0 0 1 24.5-23a59.7 59.7 0 0 0 82.6 0a81.3 81.3 0 0 1 24.5 23A87.6 87.6 0 0 0 216 128Z"
    ></path>
  </svg>
  <svg
    v-else-if="name === 'trash'"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    enable-background="new 0 0 512 512"
    xml:space="preserve"
  >
    <g>
      <path
        fill="currentColor"
        d="M128,405.429C128,428.846,147.198,448,170.667,448h170.667C364.802,448,384,428.846,384,405.429V160H128V405.429z M416,96
		h-80l-26.785-32H202.786L176,96H96v32h320V96z"
      ></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'security'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <path
      d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12c5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'setting'"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z"
      fill="currentColor"
    ></path>
    <path
      opacity="0.3"
      d="M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'brand'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <g fill="none">
      <path
        d="M5.75 3A2.75 2.75 0 0 0 3 5.75v4.785a3.975 3.975 0 0 1 1.5-.504V5.75c0-.69.56-1.25 1.25-1.25H11v1.25A2.25 2.25 0 0 0 13.25 8h6.25v10.25c0 .69-.56 1.25-1.25 1.25h-4.28a3.975 3.975 0 0 1-.505 1.5h4.785A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3H5.75zM19.5 6.5h-6.25a.75.75 0 0 1-.75-.75V4.5h5.75c.69 0 1.25.56 1.25 1.25v.75zM5 11a3 3 0 0 0-3 3v5c0 .556.151 1.077.415 1.524L5.91 17.03a2.25 2.25 0 0 1 3.182 0l3.494 3.494c.264-.447.415-.968.415-1.524v-5a3 3 0 0 0-3-3H5zm0 11a2.985 2.985 0 0 1-1.524-.415L6.97 18.09a.75.75 0 0 1 1.06 0l3.494 3.494A2.985 2.985 0 0 1 10 22H5zm5-7a1 1 0 1 1 0-2a1 1 0 0 1 0 2z"
        fill="currentColor"
      ></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'setting-2'"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    class="MuiTab-iconWrapper"
    width="20"
    height="20"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
    style="transform: rotate(360deg)"
  >
    <path
      fill="currentColor"
      d="M9.954 2.21a9.99 9.99 0 0 1 4.091-.002A3.993 3.993 0 0 0 16 5.07a3.993 3.993 0 0 0 3.457.261A9.99 9.99 0 0 1 21.5 8.876A3.993 3.993 0 0 0 20 12a3.99 3.99 0 0 0 1.502 3.124a10.043 10.043 0 0 1-2.046 3.543a3.993 3.993 0 0 0-3.456.261a3.993 3.993 0 0 0-1.954 2.86a9.99 9.99 0 0 1-4.091.004A3.993 3.993 0 0 0 8 18.927a3.993 3.993 0 0 0-3.457-.26A9.99 9.99 0 0 1 2.5 15.121A3.993 3.993 0 0 0 4 11.999a3.993 3.993 0 0 0-1.502-3.124a10.043 10.043 0 0 1 2.046-3.543A3.993 3.993 0 0 0 8 5.071a3.993 3.993 0 0 0 1.954-2.86zM12 15a3 3 0 1 0 0-6a3 3 0 0 0 0 6z"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'setting-3'"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="m13.783 15.172l2.121-2.121l5.996 5.996l-2.121 2.121zM17.5 10c1.93 0 3.5-1.57 3.5-3.5c0-.58-.16-1.12-.41-1.6l-2.7 2.7l-1.49-1.49l2.7-2.7c-.48-.25-1.02-.41-1.6-.41C15.57 3 14 4.57 14 6.5c0 .41.08.8.21 1.16l-1.85 1.85l-1.78-1.78l.71-.71l-1.41-1.41L12 3.49a3 3 0 0 0-4.24 0L4.22 7.03l1.41 1.41H2.81l-.71.71l3.54 3.54l.71-.71V9.15l1.41 1.41l.71-.71l1.78 1.78l-7.41 7.41l2.12 2.12L16.34 9.79c.36.13.75.21 1.16.21z"
    />
  </svg>

  <svg
    v-else-if="name === 'subscription'"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    class="MuiBox-root css-v2kfba"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 256 256"
    style="transform: rotate(360deg)"
  >
    <path
      fill="currentColor"
      d="M101.6 187.1c-5.4 16.4-18.4 28.4-37.5 34.8a91.8 91.8 0 0 1-26.6 4.6a8 8 0 0 1-8-8a91.8 91.8 0 0 1 4.6-26.6c6.4-19.1 18.4-32.1 34.8-37.5a8 8 0 1 1 5.1 15.1c-19.7 6.6-25.8 27.9-27.7 40.2c12.3-1.9 33.6-8 40.2-27.7a8 8 0 0 1 15.1 5.1Zm99.9-76.1l-8.9 9v61.3a16.2 16.2 0 0 1-4.7 11.3l-32.4 32.3a15.6 15.6 0 0 1-11.3 4.7a14.7 14.7 0 0 1-4.6-.7a16 16 0 0 1-11.1-12.2l-7.9-39.5l-41.8-41.8l-39.5-7.9a16 16 0 0 1-12.2-11.1a15.9 15.9 0 0 1 4-15.9l32.3-32.4a16.2 16.2 0 0 1 11.3-4.7H136l9-8.9c28.6-28.6 57.9-27.8 69.2-26.1a15.7 15.7 0 0 1 13.4 13.4c1.7 11.3 2.5 40.6-26.1 69.2Zm-159.1.8l37.7 7.5L120 79.4H74.7ZM176.6 136l-39.9 39.9l7.5 37.7l32.4-32.3Z"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'deposit-money'"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M9.368 1.222a1 1 0 0 0-1.414.15L5.058 5h1.28l2.397-3.004l.77.629L7.575 5h1.288l1.417-1.744l1.718 1.403L11.7 5h.3a3 3 0 0 1 .88.131a1 1 0 0 0-.25-1.245L9.368 1.222ZM3 5.5a.5.5 0 0 1 .5-.5h.558l.795-1H3.5A1.5 1.5 0 0 0 2 5.5v6A2.5 2.5 0 0 0 4.5 14H12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H3.5a.5.5 0 0 1-.5-.5Zm7.5 4.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1Z"
    />
  </svg>
  <svg
    v-else-if="name === 'control-panel'"
    class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-10dohqv"
    focusable="false"
    aria-hidden="true"
    viewBox="0 0 24 24"
    data-testid="MemoryIcon"
  >
    <path
      d="M15 9H9v6h6V9zm-2 4h-2v-2h2v2zm8-2V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2zm-4 6H7V7h10v10z"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'edit'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32"
  >
    <path d="M2 26h28v2H2z" fill="currentColor"></path>
    <path
      d="M25.4 9c.8-.8.8-2 0-2.8l-3.6-3.6c-.8-.8-2-.8-2.8 0l-15 15V24h6.4l15-15zm-5-5L24 7.6l-3 3L17.4 7l3-3zM6 22v-3.6l10-10l3.6 3.6l-10 10H6z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'plus'"
    focusable="false"
    aria-hidden="true"
    viewBox="0 0 24 24"
    data-testid="AddIcon"
  >
    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path>
  </svg>

  <svg
    v-else-if="name === 'plus-circle'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32"
  >
    <path
      d="M16 4c6.6 0 12 5.4 12 12s-5.4 12-12 12S4 22.6 4 16S9.4 4 16 4m0-2C8.3 2 2 8.3 2 16s6.3 14 14 14s14-6.3 14-14S23.7 2 16 2z"
      fill="currentColor"
    ></path>
    <path d="M24 15h-7V8h-2v7H8v2h7v7h2v-7h7z" fill="currentColor"></path>
  </svg>

  <!-- remove, minus, substract -->
  <svg
    v-else-if="name === 'minus-circle'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32"
  >
    <path
      d="M16 4c6.6 0 12 5.4 12 12s-5.4 12-12 12S4 22.6 4 16S9.4 4 16 4m0-2C8.3 2 2 8.3 2 16s6.3 14 14 14s14-6.3 14-14S23.7 2 16 2z"
      fill="currentColor"
    ></path>
    <path d="M8 15h16v2H8z" fill="currentColor"></path>
  </svg>

  <svg
    v-else-if="name === 'time'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 1024 1024"
  >
    <defs></defs>
    <path
      d="M945 412H689c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h256c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM811 548H689c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h122c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM477.3 322.5H434c-6.2 0-11.2 5-11.2 11.2v248c0 3.6 1.7 6.9 4.6 9l148.9 108.6c5 3.6 12 2.6 15.6-2.4l25.7-35.1v-.1c3.6-5 2.5-12-2.5-15.6l-126.7-91.6V333.7c.1-6.2-5-11.2-11.1-11.2z"
      fill="currentColor"
    ></path>
    <path
      d="M804.8 673.9H747c-5.6 0-10.9 2.9-13.9 7.7c-12.7 20.1-27.5 38.7-44.5 55.7c-29.3 29.3-63.4 52.3-101.3 68.3c-39.3 16.6-81 25-124 25c-43.1 0-84.8-8.4-124-25c-37.9-16-72-39-101.3-68.3s-52.3-63.4-68.3-101.3c-16.6-39.2-25-80.9-25-124c0-43.1 8.4-84.7 25-124c16-37.9 39-72 68.3-101.3c29.3-29.3 63.4-52.3 101.3-68.3c39.2-16.6 81-25 124-25c43.1 0 84.8 8.4 124 25c37.9 16 72 39 101.3 68.3c17 17 31.8 35.6 44.5 55.7c3 4.8 8.3 7.7 13.9 7.7h57.8c6.9 0 11.3-7.2 8.2-13.3c-65.2-129.7-197.4-214-345-215.7c-216.1-2.7-395.6 174.2-396 390.1C71.6 727.5 246.9 903 463.2 903c149.5 0 283.9-84.6 349.8-215.8c3.1-6.1-1.4-13.3-8.2-13.3z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'config'"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 256 256"
    style="transform: rotate(360deg)"
  >
    <path
      fill="currentColor"
      d="M120 56v48a16 16 0 0 1-16 16H56a16 16 0 0 1-16-16V56a16 16 0 0 1 16-16h48a16 16 0 0 1 16 16Zm-16 80H56a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h48a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16Zm96-96h-48a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h48a16 16 0 0 0 16-16V56a16 16 0 0 0-16-16Zm-56 144a8 8 0 0 0 8-8v-32a8 8 0 0 0-16 0v32a8 8 0 0 0 8 8Zm64-32h-24v-8a8 8 0 0 0-16 0v56h-24a8 8 0 0 0 0 16h32a8 8 0 0 0 8-8v-40h24a8 8 0 0 0 0-16Zm0 32a8 8 0 0 0-8 8v16a8 8 0 0 0 16 0v-16a8 8 0 0 0-8-8Z"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'gateway'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 28 28"
  >
    <g fill="none">
      <path
        d="M18.5 16.4a.9.9 0 0 0 0 1.8h3a.9.9 0 0 0 0-1.8h-3zM4.75 5A2.75 2.75 0 0 0 2 7.75v11.5A2.75 2.75 0 0 0 4.75 22h18.5A2.75 2.75 0 0 0 26 19.25V7.75A2.75 2.75 0 0 0 23.25 5H4.75zM3.5 19.25V11.5h21v7.75c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25zm0-9.25V7.75c0-.69.56-1.25 1.25-1.25h18.5c.69 0 1.25.56 1.25 1.25V10h-21z"
        fill="currentColor"
      ></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'eye'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
  >
    <path
      d="M255.66 112c-77.94 0-157.89 45.11-220.83 135.33a16 16 0 0 0-.27 17.77C82.92 340.8 161.8 400 255.66 400c92.84 0 173.34-59.38 221.79-135.25a16.14 16.14 0 0 0 0-17.47C428.89 172.28 347.8 112 255.66 112z"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
    ></path>
    <circle
      cx="256"
      cy="256"
      r="80"
      fill="none"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-width="32"
    ></circle>
  </svg>

  <svg
    v-else-if="name === 'eye-invisible'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
  >
    <path
      d="M432 448a15.92 15.92 0 0 1-11.31-4.69l-352-352a16 16 0 0 1 22.62-22.62l352 352A16 16 0 0 1 432 448z"
      fill="currentColor"
    ></path>
    <path
      d="M255.66 384c-41.49 0-81.5-12.28-118.92-36.5c-34.07-22-64.74-53.51-88.7-91v-.08c19.94-28.57 41.78-52.73 65.24-72.21a2 2 0 0 0 .14-2.94L93.5 161.38a2 2 0 0 0-2.71-.12c-24.92 21-48.05 46.76-69.08 76.92a31.92 31.92 0 0 0-.64 35.54c26.41 41.33 60.4 76.14 98.28 100.65C162 402 207.9 416 255.66 416a239.13 239.13 0 0 0 75.8-12.58a2 2 0 0 0 .77-3.31l-21.58-21.58a4 4 0 0 0-3.83-1a204.8 204.8 0 0 1-51.16 6.47z"
      fill="currentColor"
    ></path>
    <path
      d="M490.84 238.6c-26.46-40.92-60.79-75.68-99.27-100.53C349 110.55 302 96 255.66 96a227.34 227.34 0 0 0-74.89 12.83a2 2 0 0 0-.75 3.31l21.55 21.55a4 4 0 0 0 3.88 1a192.82 192.82 0 0 1 50.21-6.69c40.69 0 80.58 12.43 118.55 37c34.71 22.4 65.74 53.88 89.76 91a.13.13 0 0 1 0 .16a310.72 310.72 0 0 1-64.12 72.73a2 2 0 0 0-.15 2.95l19.9 19.89a2 2 0 0 0 2.7.13a343.49 343.49 0 0 0 68.64-78.48a32.2 32.2 0 0 0-.1-34.78z"
      fill="currentColor"
    ></path>
    <path
      d="M256 160a95.88 95.88 0 0 0-21.37 2.4a2 2 0 0 0-1 3.38l112.59 112.56a2 2 0 0 0 3.38-1A96 96 0 0 0 256 160z"
      fill="currentColor"
    ></path>
    <path
      d="M165.78 233.66a2 2 0 0 0-3.38 1a96 96 0 0 0 115 115a2 2 0 0 0 1-3.38z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'form'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <g fill="none">
      <path
        d="M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h6.272a6.471 6.471 0 0 1-.709-1.5H5.75c-.69 0-1.25-.56-1.25-1.25V5.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v5.563a6.471 6.471 0 0 1 1.5.709V5.75A2.75 2.75 0 0 0 18.25 3H5.75zm12.207 8.016a.749.749 0 0 0-.703-1.014H12.25a.75.75 0 0 0 0 1.5h2.742a6.48 6.48 0 0 1 2.965-.486zM8.25 8.502a2.25 2.25 0 1 0 0 4.5a2.25 2.25 0 0 0 0-4.5zm-.75 2.25a.75.75 0 1 1 1.5 0a.75.75 0 0 1-1.5 0zM6 16.25a2.25 2.25 0 1 1 4.5 0a2.25 2.25 0 0 1-4.5 0zm2.25-.75a.75.75 0 1 0 0 1.5a.75.75 0 0 0 0-1.5zm9.004-8h-10.5a.75.75 0 1 1 0-1.5h10.5a.75.75 0 0 1 0 1.5zM23 17.5a5.5 5.5 0 1 0-11 0a5.5 5.5 0 0 0 11 0zm-4.999 3.003a.5.5 0 1 1-1 0V18h-2.505a.5.5 0 1 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.503a.5.5 0 1 1 0 1h-2.502v2.503z"
        fill="currentColor"
      ></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'components'"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <g
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M3 12l3 3l3-3l-3-3z"></path>
      <path d="M15 12l3 3l3-3l-3-3z"></path>
      <path d="M9 6l3 3l3-3l-3-3z"></path>
      <path d="M9 18l3 3l3-3l-3-3z"></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'active-user'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32"
  >
    <path
      d="M12 4a5 5 0 1 1-5 5a5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7a7 7 0 0 0-7-7z"
      fill="currentColor"
    ></path>
    <path
      d="M22 30h-2v-5a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v5H2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7z"
      fill="currentColor"
    ></path>
    <path
      d="M25 16.18l-2.59-2.59L21 15l4 4l7-7l-1.41-1.41L25 16.18z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'banned-user'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <g
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path
        d="M14.274 10.291a4 4 0 1 0-5.554-5.58m-.548 3.453a4.01 4.01 0 0 0 2.62 2.65"
      ></path>
      <path
        d="M6 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 1.147.167m2.685 2.681A4 4 0 0 1 18 19v2"
      ></path>
      <path d="M3 3l18 18"></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'unverified-user'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <g
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="9" cy="7" r="4"></circle>
      <path d="M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2"></path>
      <path d="M19 7v3"></path>
      <path d="M19 14v.01"></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'trend'"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
    style="transform: rotate(360deg)"
  >
    <path
      fill="currentColor"
      d="m3.897 17.86l3.91-3.91l2.829 2.828l4.571-4.57L17 14V9h-5l1.793 1.793l-3.157 3.157l-2.828-2.829l-4.946 4.946A9.965 9.965 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10a9.987 9.987 0 0 1-8.103-4.14z"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'deposits'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 16 16"
  >
    <g fill="none">
      <path
        d="M10.5 10a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zM1 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5zm13 0a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1h12V5zM2 11a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7H2v4z"
        fill="currentColor"
      ></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'exchange-2'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
  >
    <path
      d="M0 168v-16c0-13.255 10.745-24 24-24h360V80c0-21.367 25.899-32.042 40.971-16.971l80 80c9.372 9.373 9.372 24.569 0 33.941l-80 80C409.956 271.982 384 261.456 384 240v-48H24c-13.255 0-24-10.745-24-24zm488 152H128v-48c0-21.314-25.862-32.08-40.971-16.971l-80 80c-9.372 9.373-9.372 24.569 0 33.941l80 80C102.057 463.997 128 453.437 128 432v-48h360c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'bell'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 448 512"
  >
    <path
      d="M439.39 362.29c-19.32-20.76-55.47-51.99-55.47-154.29c0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29c-6 6.45-8.66 14.16-8.61 21.71c.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32c.05-7.55-2.61-15.27-8.61-21.71zM67.53 368c21.22-27.97 44.42-74.33 44.53-159.42c0-.2-.06-.38-.06-.58c0-61.86 50.14-112 112-112s112 50.14 112 112c0 .2-.06.38-.06.58c.11 85.1 23.31 131.46 44.53 159.42H67.53zM224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'stop-circle'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 1024 1024"
  >
    <path
      d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448s448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372c0-89 31.3-170.8 83.5-234.8l523.3 523.3C682.8 852.7 601 884 512 884zm288.5-137.2L277.2 223.5C341.2 171.3 423 140 512 140c205.4 0 372 166.6 372 372c0 89-31.3 170.8-83.5 234.8z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'unstop'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M0 3.75a.75.75 0 0 1 1.5 0v.943a5 5 0 1 1 .67 7.246a.75.75 0 1 1 .924-1.182A3.5 3.5 0 1 0 2.088 6.5H4.25a.75.75 0 0 1 0 1.5H0V3.75Zm12 0a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75ZM12 8a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 12 8Zm.75 3.5a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5Z"
      clip-rule="evenodd"
    />
  </svg>

  <svg
    v-else-if="name === 'invoice'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
  >
    <path
      fill="currentColor"
      d="M6 3v26h16v-2H8V5h10v6h6v2h2V9.6l-.3-.3l-6-6l-.3-.3H6zm14 3.4L22.6 9H20V6.4zM10 13v2h12v-2H10zm17 2v2c-1.7.3-3 1.7-3 3.5c0 2 1.5 3.5 3.5 3.5h1c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5H25v2h2v2h2v-2c1.7-.3 3-1.7 3-3.5c0-2-1.5-3.5-3.5-3.5h-1c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5H31v-2h-2v-2h-2zm-17 3v2h7v-2h-7zm9 0v2h3v-2h-3zm-9 4v2h7v-2h-7zm9 0v2h3v-2h-3z"
    />
  </svg>

  <svg
    v-else-if="name === 'pending'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M17 22q-2.075 0-3.538-1.463T12 17q0-2.075 1.463-3.538T17 12q2.075 0 3.538 1.463T22 17q0 2.075-1.463 3.538T17 22Zm1.675-2.625l.7-.7L17.5 16.8V14h-1v3.2l2.175 2.175ZM5 21q-.825 0-1.413-.588T3 19V5q0-.825.588-1.413T5 3h4.175q.275-.875 1.075-1.438T12 1q1 0 1.788.563T14.85 3H19q.825 0 1.413.588T21 5v6.25q-.45-.325-.95-.55T19 10.3V5h-2v3H7V5H5v14h5.3q.175.55.4 1.05t.55.95H5Zm7-16q.425 0 .713-.288T13 4q0-.425-.288-.713T12 3q-.425 0-.713.288T11 4q0 .425.288.713T12 5Z"
    />
  </svg>

  <svg
    v-else-if="name === 'approved'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="m17.275 20.25l3.475-3.45l-1.05-1.05l-2.425 2.375l-.975-.975l-1.05 1.075l2.025 2.025ZM6 9h12V7H6v2Zm12 14q-2.075 0-3.538-1.463T13 18q0-2.075 1.463-3.538T18 13q2.075 0 3.538 1.463T23 18q0 2.075-1.463 3.538T18 23ZM3 22V3h18v8.675q-.475-.225-.975-.375T19 11.075V5H5v14.05h6.075q.125.775.388 1.475t.687 1.325L12 22l-1.5-1.5L9 22l-1.5-1.5L6 22l-1.5-1.5L3 22Zm3-5h5.075q.075-.525.225-1.025t.375-.975H6v2Zm0-4h7.1q.95-.925 2.213-1.463T18 11H6v2Zm-1 6.05V5v14.05Z"
    />
  </svg>

  <svg
    v-else-if="name === 'successful'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M12.925 11.05L8.675 6.8L10.1 5.4l2.825 2.825l5.675-5.65l1.4 1.4l-7.075 7.075ZM14 22.5l-7-1.95V22H1V11h7.95l6.2 2.3q.825.3 1.337 1.05T17 16h2q1.25 0 2.125.825T22 19v1l-8 2.5ZM3 20h2v-7H3v7Zm10.95.4l5.95-1.85q-.075-.275-.337-.413T19 18h-4.8q-.775 0-1.4-.1t-1.35-.35l-1.725-.6l.575-1.9l2 .65q.45.15 1.05.225T15 16q0-.275-.162-.525t-.388-.325L8.6 13H7v5.5l6.95 1.9ZM5 16.5Zm10-.5Zm-10 .5Zm2 0Z"
    />
  </svg>

  <svg
    v-else-if="name === 'initiat'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M11 21v-2h2v2h-2Zm0-16V3h2v2h-2Zm4 16v-2h2v2h-2Zm0-16V3h2v2h-2Zm4 12v-2h2v2h-2Zm0-4v-2h2v2h-2Zm0-4V7h2v2h-2ZM5 19V5H4q-.425 0-.713-.288T3 4q0-.425.288-.713T4 3h4q.425 0 .713.288T9 4q0 .425-.288.713T8 5H7v14h1q.425 0 .713.288T9 20q0 .425-.288.713T8 21H4q-.425 0-.713-.288T3 20q0-.425.288-.713T4 19h1ZM19 5V3q.825 0 1.413.588T21 5h-2Zm0 16v-2h2q0 .825-.588 1.413T19 21Z"
    />
  </svg>

  <svg
    v-else-if="name === 'send'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
  >
    <path
      fill="currentColor"
      d="M27.71 4.29a1 1 0 0 0-1.05-.23l-22 8a1 1 0 0 0 0 1.87l9.6 3.84l3.84 9.6a1 1 0 0 0 .9.63a1 1 0 0 0 .92-.66l8-22a1 1 0 0 0-.21-1.05ZM19 24.2l-2.79-7L21 12.41L19.59 11l-4.83 4.83L7.8 13l17.53-6.33Z"
    />
  </svg>

  <svg
    v-else-if="name === 'tick'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15 15"
  >
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M14.707 3L5.5 12.207L.293 7L1 6.293l4.5 4.5l8.5-8.5l.707.707Z"
      clip-rule="evenodd"
    />
  </svg>

  <svg
    v-else-if="name === 'check-circle'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M16.59 7.58L10 14.17l-3.59-3.58L5 12l5 5l8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8s8 3.58 8 8s-3.58 8-8 8z"
    />
  </svg>
  <svg
    v-else-if="name === 'user_sponsor_income'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <g fill="none">
      <path
        d="M15.5 13.75a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75zM3 5h.014A2.25 2.25 0 0 1 5.25 3h11.5A2.25 2.25 0 0 1 19 5.25v.837a3.251 3.251 0 0 1 2.5 3.163v8.5A3.25 3.25 0 0 1 18.25 21h-12A3.25 3.25 0 0 1 3 17.75V5zm15.25 2.5H4.5v10.25c0 .966.784 1.75 1.75 1.75h12A1.75 1.75 0 0 0 20 17.75v-8.5a1.75 1.75 0 0 0-1.75-1.75zM17.5 6v-.75a.75.75 0 0 0-.75-.75H5.25a.75.75 0 0 0 0 1.5H17.5z"
        fill="currentColor"
      ></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'active-investment'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M17.45 15.18L22 7.31V21H2V3h2v12.54L9.5 6L16 9.78l4.24-7.33l1.73 1l-5.23 9.05l-6.51-3.75L4.31 19h2.26l4.39-7.56l6.49 3.74Z"
    />
  </svg>

  <svg
    v-else-if="name === 'close-investment'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="m17 4l4 4l-4 4V9h-4V7h4V4zm-7 3c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1zM6 7c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1zm1 10h4v-2H7v-3l-4 4l4 4v-3zm7 0c.55 0 1-.45 1-1s-.45-1-1-1s-1 .45-1 1s.45 1 1 1zm4 0c.55 0 1-.45 1-1s-.45-1-1-1s-1 .45-1 1s.45 1 1 1z"
    />
  </svg>

  <svg
    v-else-if="name === 'Inertia'"
    width="32"
    height="32"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M6.901 5.331H0L6.669 12L0 18.669h6.901L13.571 12zm10.43 0H10.43L17.099 12l-6.67 6.669h6.902L24 12z"
    />
  </svg>

  <svg
    v-else-if="name === 'my-ref-name'"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32"
  >
    <path
      d="M21 22h-2v-2a1.001 1.001 0 0 0-1-1h-4a1.001 1.001 0 0 0-1 1v2h-2v-2a3.003 3.003 0 0 1 3-3h4a3.003 3.003 0 0 1 3 3z"
      fill="currentColor"
    ></path>
    <path
      d="M16 16a3.5 3.5 0 1 1 3.5-3.5A3.504 3.504 0 0 1 16 16zm0-5a1.5 1.5 0 1 0 1.5 1.5A1.502 1.502 0 0 0 16 11z"
      fill="currentColor"
    ></path>
    <path
      d="M30.414 17.414a2 2 0 0 0 0-2.828l-5.787-5.787l2.9-2.862a2.002 2.002 0 1 0-1.44-1.388l-2.874 2.836l-5.799-5.8a2 2 0 0 0-2.828 0L8.799 7.374L5.937 4.472A2.002 2.002 0 1 0 4.55 5.914l2.835 2.873l-5.8 5.799a2 2 0 0 0 0 2.828l5.8 5.799l-2.835 2.873a1.998 1.998 0 1 0 1.387 1.442l2.862-2.9l5.787 5.786a2 2 0 0 0 2.828 0l5.8-5.799l2.872 2.836a1.998 1.998 0 1 0 1.442-1.387l-2.9-2.863zM16 29L3 16L16 3l13 13z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'seo'"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 48 48"
  >
    <mask id="ipSSeo0">
      <g fill="none" stroke-width="4">
        <rect
          width="40"
          height="32"
          x="4"
          y="8"
          fill="#fff"
          stroke="#fff"
          rx="1.633"
        />
        <path
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M16 18.948c-2-2.948-5.502-1.01-5.251 2.02C11 24 15 24 15.249 27.032C15.5 30.062 12 32 10 29.051M26 18h-4v13h4m-4-6h4"
        />
        <rect
          width="6"
          height="13"
          x="32"
          y="18"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          rx="3"
        />
      </g>
    </mask>
    <path fill="currentColor" d="M0 0h48v48H0z" mask="url(#ipSSeo0)" />
  </svg>
  <svg
    v-else-if="name === 'login'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M11 7L9.6 8.4l2.6 2.6H2v2h10.2l-2.6 2.6L11 17l5-5l-5-5zm9 12h-8v2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-8v2h8v14z"
    />
  </svg>

  <svg
    v-else-if="name === 'credit-card'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path fill="currentColor" d="M4 12h16v6H4zm0-6h16v2H4z" opacity=".3" />
    <path
      fill="currentColor"
      d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
    />
  </svg>

  <svg
    v-else-if="name === 'transfer'"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.3"
      d="M8.9 21L7.19999 22.6999C6.79999 23.0999 6.2 23.0999 5.8 22.6999L4.1 21H8.9ZM4 16.0999L2.3 17.8C1.9 18.2 1.9 18.7999 2.3 19.1999L4 20.9V16.0999ZM19.3 9.1999L15.8 5.6999C15.4 5.2999 14.8 5.2999 14.4 5.6999L9 11.0999V21L19.3 10.6999C19.7 10.2999 19.7 9.5999 19.3 9.1999Z"
      fill="currentColor"
    />
    <path
      d="M21 15V20C21 20.6 20.6 21 20 21H11.8L18.8 14H20C20.6 14 21 14.4 21 15ZM10 21V4C10 3.4 9.6 3 9 3H4C3.4 3 3 3.4 3 4V21C3 21.6 3.4 22 4 22H9C9.6 22 10 21.6 10 21ZM7.5 18.5C7.5 19.1 7.1 19.5 6.5 19.5C5.9 19.5 5.5 19.1 5.5 18.5C5.5 17.9 5.9 17.5 6.5 17.5C7.1 17.5 7.5 17.9 7.5 18.5Z"
      fill="currentColor"
    />
  </svg>

  <svg
    v-else-if="name === 'extension'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M13.5 1.5L15 0h7.5L24 1.5V9l-1.5 1.5H15L13.5 9V1.5zm1.5 0V9h7.5V1.5H15zM0 15V6l1.5-1.5H9L10.5 6v7.5H18l1.5 1.5v7.5L18 24H1.5L0 22.5V15zm9-1.5V6H1.5v7.5H9zM9 15H1.5v7.5H9V15zm1.5 7.5H18V15h-7.5v7.5z"
      clip-rule="evenodd"
    />
  </svg>

  <svg
    v-else-if="name === 'globe'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 1024 1024"
  >
    <path
      d="M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8c-1.1-1.3-2.1-2.5-3.2-3.7c-.4-.5-.8-.9-1.2-1.4l-4.1-4.7l-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1l-4.8-4.8l-.3-.3c-1.5-1.5-3-2.9-4.5-4.3c-.5-.5-1-1-1.6-1.5c-1-1-2-1.9-3-2.8c-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1c-1 .9-2 1.9-3 2.9c-.5.5-1 1-1.6 1.5c-1.5 1.4-3 2.9-4.5 4.3l-.3.3l-4.8 4.8l-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7c-.4.5-.8.9-1.2 1.4c-1.1 1.2-2.1 2.5-3.2 3.7c-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2c1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6c80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0 0 10-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5c0-.1.1-.1.1-.2c1.4-1.5 2.8-3.1 4.1-4.7c.4-.5.8-.9 1.2-1.4a99 99 0 0 0 3.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 0 0-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6c29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 0 1 887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 0 1-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4c3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 0 1 115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8c-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 0 1 540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4c21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 0 0 540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4c-21.2-16.7-41.7-42.7-59.1-75.1c-11-20.6-20.7-43.3-29-67.8c37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 0 1-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8c17.4-32.4 37.8-58.4 59.1-75.1c9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4c-23.4 31.3-43.5 70.4-59.2 115.4c-21-12-40.9-26-59.4-41.8c31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2c24.9 21.5 52.2 40.3 81.5 55.9c-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 0 0-81.5 55.9A373.86 373.86 0 0 1 137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2c18.5-15.8 38.4-29.7 59.4-41.8c15.7 45 35.8 84.1 59.2 115.4c-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4c23.4-31.3 43.5-70.4 59.2-115.4c21 12 40.9 26 59.4 41.8a373.81 373.81 0 0 1-107.6 69.2z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'website'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 20 20"
  >
    <g fill="none">
      <path
        d="M9.386 4.29l-1.32-.99a1.5 1.5 0 0 0-.9-.3H4.5A2.5 2.5 0 0 0 2 5.5v1h5.07a.5.5 0 0 0 .363-.156L9.386 4.29zm1.179.21L8.158 7.033a1.5 1.5 0 0 1-1.087.467H2v7A2.5 2.5 0 0 0 4.5 17h5.1a5.5 5.5 0 0 1 8.4-6.743V7l-.005-.164A2.5 2.5 0 0 0 15.5 4.5h-4.935zM13.01 14c.047-1.128.25-2.123.54-2.85c.167-.417.353-.722.535-.914c.18-.19.32-.236.415-.236c.094 0 .235.046.415.236c.182.192.368.497.535.914c.29.727.493 1.722.54 2.85h-2.98zm-.389-3.221c.064-.16.134-.314.208-.459A4.505 4.505 0 0 0 10.027 14h1.982c.047-1.234.268-2.36.612-3.221zm3.757 0a5.285 5.285 0 0 0-.208-.459A4.504 4.504 0 0 1 18.972 14H16.99c-.047-1.234-.267-2.36-.612-3.221zM16.99 15h1.982a4.504 4.504 0 0 1-2.802 3.68c.075-.145.144-.299.208-.459c.345-.862.565-1.987.612-3.221zm-2.075 3.764c-.18.19-.32.236-.415.236c-.095 0-.235-.046-.415-.236c-.182-.192-.368-.497-.535-.914c-.29-.727-.493-1.722-.54-2.85h2.98c-.047 1.128-.25 2.123-.54 2.85c-.167.417-.353.722-.535.913zM10.027 15a4.505 4.505 0 0 0 2.802 3.68a5.346 5.346 0 0 1-.208-.459c-.344-.862-.565-1.987-.612-3.221h-1.982z"
        fill="currentColor"
      ></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'deposit'"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.43 8.56949L10.744 15.1395C10.6422 15.282 10.5804 15.4492 10.5651 15.6236C10.5498 15.7981 10.5815 15.9734 10.657 16.1315L13.194 21.4425C13.2737 21.6097 13.3991 21.751 13.5557 21.8499C13.7123 21.9488 13.8938 22.0014 14.079 22.0015H14.117C14.3087 21.9941 14.4941 21.9307 14.6502 21.8191C14.8062 21.7075 14.9261 21.5526 14.995 21.3735L21.933 3.33649C22.0011 3.15918 22.0164 2.96594 21.977 2.78013C21.9376 2.59432 21.8452 2.4239 21.711 2.28949L15.43 8.56949Z"
      fill="currentColor"
    />
    <path
      opacity="0.3"
      d="M20.664 2.06648L2.62602 9.00148C2.44768 9.07085 2.29348 9.19082 2.1824 9.34663C2.07131 9.50244 2.00818 9.68731 2.00074 9.87853C1.99331 10.0697 2.04189 10.259 2.14054 10.4229C2.23919 10.5869 2.38359 10.7185 2.55601 10.8015L7.86601 13.3365C8.02383 13.4126 8.19925 13.4448 8.37382 13.4297C8.54839 13.4145 8.71565 13.3526 8.85801 13.2505L15.43 8.56548L21.711 2.28448C21.5762 2.15096 21.4055 2.05932 21.2198 2.02064C21.034 1.98196 20.8409 1.99788 20.664 2.06648Z"
      fill="currentColor"
    />
  </svg>

  <svg
    v-else-if="name === 'deposit-2'"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.3"
      d="M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z"
      fill="currentColor"
    />
    <path
      d="M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z"
      fill="currentColor"
    />
  </svg>

  <svg
    v-else-if="name === 'alluser'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 640 512"
  >
    <path
      d="M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32S80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96s43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4c24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48c0-61.9-50.1-112-112-112z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'banned_users'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <g
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path
        d="M14.274 10.291a4 4 0 1 0-5.554-5.58m-.548 3.453a4.01 4.01 0 0 0 2.62 2.65"
      ></path>
      <path
        d="M6 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 1.147.167m2.685 2.681A4 4 0 0 1 18 19v2"
      ></path>
      <path d="M3 3l18 18"></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'verified_users'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <path
      d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h8v-2H4V8l8 5l8-5v5h2V6c0-1.1-.9-2-2-2zm-8 7L4 6h16l-8 5zm5.34 11l-3.54-3.54l1.41-1.41l2.12 2.12l4.24-4.24L23 16.34L17.34 22z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'email_unverified_users'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <path
      d="M19 10c1.13 0 2.16-.39 3-1.02V18c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h10.1c-.06.32-.1.66-.1 1c0 1.48.65 2.79 1.67 3.71L12 11L5.3 6.81a.85.85 0 1 0-.9 1.44l7.07 4.42c.32.2.74.2 1.06 0l4.77-2.98c.54.19 1.1.31 1.7.31zm-3-5c0 1.66 1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3s-3 1.34-3 3z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'All_User_Income'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 20 20"
  >
    <g fill="none">
      <path
        d="M7 2H4.75A2.75 2.75 0 0 0 2 4.75V7h2.268A2 2 0 0 1 7 4.268V2zm1 4v1h1a1 1 0 1 0-1-1zm2.732 1A2 2 0 0 0 8 4.268V2h7.25A2.75 2.75 0 0 1 18 4.75V7h-7.268zM8.707 8l1.647 1.646a.5.5 0 0 1-.708.708L8 8.707V14h1v-.5a2.5 2.5 0 0 1 2.5-2.5h6c.171 0 .338.017.5.05V8H8.707zM7 14V8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L6.293 8H2v3.25A2.75 2.75 0 0 0 4.75 14H7zm0-8a1 1 0 1 0-1 1h1V6zm12 7.5v3a1.5 1.5 0 0 1-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-3a1.5 1.5 0 0 1 1.5-1.5h6a1.5 1.5 0 0 1 1.5 1.5zm-1 3v-1a1.5 1.5 0 0 0-1.5 1.5h1a.5.5 0 0 1 .5-.5zm-.5-3.5h-1a1.5 1.5 0 0 0 1.5 1.5v-1a.5.5 0 0 1-.5-.5zm-6 0a.5.5 0 0 1-.5.5v1a1.5 1.5 0 0 0 1.5-1.5h-1zm-.5 3.5a.5.5 0 0 1 .5.5h1a1.5 1.5 0 0 0-1.5-1.5v1zm3.5-3a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3z"
        fill="currentColor"
      ></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'total_users_buy_plan'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <g
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <ellipse cx="16" cy="6" rx="5" ry="3"></ellipse>
      <path d="M11 6v4c0 1.657 2.239 3 5 3s5-1.343 5-3V6"></path>
      <path d="M11 10v4c0 1.657 2.239 3 5 3s5-1.343 5-3v-4"></path>
      <path d="M11 14v4c0 1.657 2.239 3 5 3s5-1.343 5-3v-4"></path>
      <path d="M7 9H4.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3H3"></path>
      <path d="M5 15v1m0-8v1"></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'level_income'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <g fill="none">
      <path
        d="M5 6.25A2.25 2.25 0 0 1 7.25 4h8.5A2.25 2.25 0 0 1 18 6.25V14h3.5v3.25a3.25 3.25 0 0 1-3.25 3.25H13v-4h1.25a.75.75 0 0 0 0-1.5H12.5a2.496 2.496 0 0 0-2-1H5V6.25zM18 19h.25A1.75 1.75 0 0 0 20 17.25V15.5h-2V19zM8.75 8a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5h-5.5zm0 3.5a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5h-5.5zM1 16.5A1.5 1.5 0 0 1 2.5 15h8a1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 1 20.5v-4zm10 .5a1 1 0 0 1-1-1H9a2 2 0 0 0 2 2v-1zm0 2a2 2 0 0 0-2 2h1a1 1 0 0 1 1-1v-1zm-8-3a1 1 0 0 1-1 1v1a2 2 0 0 0 2-2H3zm1 5a2 2 0 0 0-2-2v1a1 1 0 0 1 1 1h1zm4.25-2.5a1.75 1.75 0 1 0-3.5 0a1.75 1.75 0 0 0 3.5 0z"
        fill="currentColor"
      ></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'sponsorship_income'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <g fill="none">
      <path
        d="M13.5 12.501a1.5 1.5 0 0 1 1.493 1.356L15 14V15h-1.5a2.5 2.5 0 0 0-2.5 2.5v3.221A11.06 11.06 0 0 1 8.5 21c-2.722 0-6.335-.956-6.495-4.27L2 16.5V14a1.5 1.5 0 0 1 1.356-1.493L3.5 12.5l10 .001zm8 2.499c.171 0 .338.017.5.05V14l-.007-.145A1.5 1.5 0 0 0 20.5 12.5h-5.012l.113.162c.25.387.399.844.399 1.338v1h5.5zM8.5 2a4.5 4.5 0 1 1 0 9a4.5 4.5 0 0 1 0-9zm9 2a3.5 3.5 0 1 1 0 7a3.5 3.5 0 0 1 0-7zM12 17.5a1.5 1.5 0 0 1 1.5-1.5h8a1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1-1.5 1.5h-8a1.5 1.5 0 0 1-1.5-1.5v-4zm10 .5a1 1 0 0 1-1-1h-1a2 2 0 0 0 2 2v-1zm0 2a2 2 0 0 0-2 2h1a1 1 0 0 1 1-1v-1zm-8-3a1 1 0 0 1-1 1v1a2 2 0 0 0 2-2h-1zm1 5a2 2 0 0 0-2-2v1a1 1 0 0 1 1 1h1zm4.25-2.5a1.75 1.75 0 1 0-3.5 0a1.75 1.75 0 0 0 3.5 0z"
        fill="currentColor"
      ></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'registration_bonus'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <path
      opacity=".3"
      d="M12 4c-4.41 0-8 3.59-8 8c0 1.82.62 3.49 1.64 4.83c1.43-1.74 4.9-2.33 6.36-2.33s4.93.59 6.36 2.33A7.95 7.95 0 0 0 20 12c0-4.41-3.59-8-8-8zm0 9c-1.94 0-3.5-1.56-3.5-3.5S10.06 6 12 6s3.5 1.56 3.5 3.5S13.94 13 12 13z"
      fill="currentColor"
    ></path>
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zM7.07 18.28c.43-.9 3.05-1.78 4.93-1.78s4.51.88 4.93 1.78C15.57 19.36 13.86 20 12 20s-3.57-.64-4.93-1.72zm11.29-1.45c-1.43-1.74-4.9-2.33-6.36-2.33s-4.93.59-6.36 2.33A7.95 7.95 0 0 1 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.82-.62 3.49-1.64 4.83zM12 6c-1.94 0-3.5 1.56-3.5 3.5S10.06 13 12 13s3.5-1.56 3.5-3.5S13.94 6 12 6zm0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'ranking_bonus'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <g
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M17 7v13H7V7l5-3z"></path>
      <path d="M10 13l2-1l2 1"></path>
      <path d="M10 17l2-1l2 1"></path>
      <path d="M10 9l2-1l2 1"></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'balance_add'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32"
  >
    <path
      d="M27 25h-6a3 3 0 0 0-3 3v2h2v-2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2h2v-2a3 3 0 0 0-3-3z"
      fill="currentColor"
    ></path>
    <path
      d="M20 20a4 4 0 1 0 4-4a4 4 0 0 0-4 4zm6 0a2 2 0 1 1-2-2a2 2 0 0 1 2 2z"
      fill="currentColor"
    ></path>
    <path
      d="M6 21v-1H4v1a7 7 0 0 0 7 7h3v-2h-3a5 5 0 0 1-5-5z"
      fill="currentColor"
    ></path>
    <path d="M19 10h7v2h-7z" fill="currentColor"></path>
    <path d="M19 6h10v2H19z" fill="currentColor"></path>
    <path d="M19 2h10v2H19z" fill="currentColor"></path>
    <path
      d="M11 11H5a3 3 0 0 0-3 3v2h2v-2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2h2v-2a3 3 0 0 0-3-3z"
      fill="currentColor"
    ></path>
    <path
      d="M8 10a4 4 0 1 0-4-4a4 4 0 0 0 4 4zm0-6a2 2 0 1 1-2 2a2 2 0 0 1 2-2z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'today_signups'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 20 20"
  >
    <g fill="none">
      <path
        d="M14.5 3A2.5 2.5 0 0 1 17 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-3v-1h3a1.5 1.5 0 0 0 1.5-1.5V7H4v7.5A1.5 1.5 0 0 0 5.5 16h3v1h-3A2.5 2.5 0 0 1 3 14.5v-9A2.5 2.5 0 0 1 5.5 3h9zm0 1h-9A1.5 1.5 0 0 0 4 5.5V6h12v-.5A1.5 1.5 0 0 0 14.5 4zM11 9a1 1 0 1 1-2 0a1 1 0 0 1 2 0zm.884 5.07a.5.5 0 0 1-.704.064l-.68-.566V17.5a.5.5 0 1 1-1 0v-3.932l-.68.566a.5.5 0 0 1-.64-.768l1.5-1.25a.5.5 0 0 1 .64 0l1.5 1.25a.5.5 0 0 1 .064.704z"
        fill="currentColor"
      ></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'balance_subtract'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <g
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M16 4h4v4"></path>
      <path d="M15 9l5-5"></path>
      <path d="M4 20l5-5"></path>
      <path d="M16 20h4v-4"></path>
      <path d="M4 4l16 16"></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'available_Balance_All_User'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <path
      opacity=".3"
      d="M13 17c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h6V5H5v14h14v-2h-6z"
      fill="currentColor"
    ></path>
    <path
      d="M21 7.28V5c0-1.1-.9-2-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-2.28A2 2 0 0 0 22 15V9c0-.74-.41-1.38-1-1.72zM20 9v6h-7V9h7zM5 19V5h14v2h-6c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6v2H5z"
      fill="currentColor"
    ></path>
    <circle cx="16" cy="12" r="1.5" fill="currentColor"></circle>
  </svg>

  <svg
    v-else-if="name === 'available_Withdrawal_Wallet'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <path
      opacity=".3"
      d="M6.29 6l5.21-2.74L16.71 6z"
      fill="currentColor"
    ></path>
    <path
      d="M6.5 10h-2v7h2v-7zm6 0h-2v7h2v-7zm8.5 9H2v2h19v-2zm-2.5-9h-2v7h2v-7zm-7-9L2 6v2h19V6l-9.5-5zM6.29 6l5.21-2.74L16.71 6H6.29z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'available_payment_deposit_wallet'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 640 512"
  >
    <path
      d="M256 336h-.02c0-16.18 1.34-8.73-85.05-181.51c-17.65-35.29-68.19-35.36-85.87 0C-2.06 328.75.02 320.33.02 336H0c0 44.18 57.31 80 128 80s128-35.82 128-80zM128 176l72 144H56l72-144zm511.98 160c0-16.18 1.34-8.73-85.05-181.51c-17.65-35.29-68.19-35.36-85.87 0c-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 320l72-144l72 144H440zm88 128H352V153.25c23.51-10.29 41.16-31.48 46.39-57.25H528c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H383.64C369.04 12.68 346.09 0 320 0s-49.04 12.68-63.64 32H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h129.61c5.23 25.76 22.87 46.96 46.39 57.25V448H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'available-deposit-wallet'"
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 128 128"
  >
    <path
      d="M5.928 39.472a10.827 10.827 0 0 0 5.661 1.526 11.209 11.209 0 0 0 2.988-.378 2 2 0 0 0 1.407-2.163c-.543-4.346-2.233-7.534-5.024-9.475a12.745 12.745 0 0 0-9.419-1.715 2 2 0 0 0-1.507 2.314c.882 4.72 2.865 8.047 5.894 9.89zm2.775-7.187A7.93 7.93 0 0 1 11.65 37a6.559 6.559 0 0 1-3.679-.967A8.686 8.686 0 0 1 4.5 31.008a7.695 7.695 0 0 1 4.204 1.277zm3.257 11.699a12.745 12.745 0 0 0-9.419-1.715 2 2 0 0 0-1.507 2.314c.883 4.719 2.865 8.046 5.894 9.89A10.827 10.827 0 0 0 12.59 56a11.209 11.209 0 0 0 2.988-.378 2 2 0 0 0 1.407-2.163c-.543-4.347-2.233-7.534-5.024-9.475zm-2.989 7.05A8.686 8.686 0 0 1 5.5 46.01a7.695 7.695 0 0 1 4.204 1.277A7.93 7.93 0 0 1 12.65 52a6.716 6.716 0 0 1-3.679-.966zM25.423 40.62a11.209 11.209 0 0 0 2.988.378 10.828 10.828 0 0 0 5.66-1.526c3.03-1.844 5.012-5.172 5.895-9.891a2 2 0 0 0-1.507-2.314 12.74 12.74 0 0 0-9.419 1.715c-2.79 1.94-4.481 5.129-5.024 9.475a2 2 0 0 0 1.407 2.163zm5.874-8.335a7.695 7.695 0 0 1 4.204-1.277 8.686 8.686 0 0 1-3.472 5.024A7.26 7.26 0 0 1 28.35 37a7.929 7.929 0 0 1 2.947-4.715zM28.04 43.984c-2.791 1.94-4.481 5.128-5.024 9.475a2 2 0 0 0 1.407 2.163 11.209 11.209 0 0 0 2.988.378 10.828 10.828 0 0 0 5.66-1.527c3.03-1.844 5.012-5.171 5.895-9.89a2 2 0 0 0-1.507-2.314 12.745 12.745 0 0 0-9.419 1.715zm2.989 7.05A7.039 7.039 0 0 1 27.35 52a7.929 7.929 0 0 1 2.947-4.714 7.695 7.695 0 0 1 4.204-1.278 8.686 8.686 0 0 1-3.472 5.025zm62.9-11.562a10.827 10.827 0 0 0 5.66 1.526 11.209 11.209 0 0 0 2.988-.378 2 2 0 0 0 1.407-2.163c-.543-4.346-2.233-7.534-5.024-9.475a12.745 12.745 0 0 0-9.419-1.715 2 2 0 0 0-1.507 2.314c.882 4.72 2.865 8.047 5.894 9.89zm2.774-7.187A7.93 7.93 0 0 1 99.65 37a6.557 6.557 0 0 1-3.679-.967 8.686 8.686 0 0 1-3.472-5.024 7.695 7.695 0 0 1 4.204 1.277zm3.257 11.699a12.746 12.746 0 0 0-9.419-1.715 2 2 0 0 0-1.507 2.314c.883 4.719 2.865 8.046 5.894 9.89A10.827 10.827 0 0 0 100.59 56a11.209 11.209 0 0 0 2.988-.378 2 2 0 0 0 1.407-2.163c-.543-4.347-2.233-7.534-5.024-9.475zm-2.989 7.05A8.686 8.686 0 0 1 93.5 46.01a7.695 7.695 0 0 1 4.204 1.277A7.93 7.93 0 0 1 100.65 52a6.714 6.714 0 0 1-3.679-.966zm16.452-10.414a11.209 11.209 0 0 0 2.988.378 10.828 10.828 0 0 0 5.66-1.526c3.03-1.844 5.012-5.172 5.895-9.891a2 2 0 0 0-1.507-2.314 12.74 12.74 0 0 0-9.419 1.715c-2.79 1.94-4.481 5.129-5.024 9.475a2 2 0 0 0 1.407 2.163zm5.874-8.335a7.695 7.695 0 0 1 4.204-1.277 8.686 8.686 0 0 1-3.472 5.024 7.225 7.225 0 0 1-3.679.968 7.929 7.929 0 0 1 2.947-4.715zm-3.257 11.699c-2.791 1.94-4.481 5.128-5.024 9.475a2 2 0 0 0 1.407 2.163 11.209 11.209 0 0 0 2.988.378 10.828 10.828 0 0 0 5.66-1.527c3.03-1.844 5.012-5.171 5.895-9.89a2 2 0 0 0-1.507-2.314 12.745 12.745 0 0 0-9.419 1.715zm2.989 7.05a7.006 7.006 0 0 1-3.679.967 7.929 7.929 0 0 1 2.947-4.714 7.695 7.695 0 0 1 4.204-1.278 8.686 8.686 0 0 1-3.472 5.025zm-69.1-11.562a10.827 10.827 0 0 0 5.66 1.526 11.209 11.209 0 0 0 2.988-.378 2 2 0 0 0 1.407-2.163c-.543-4.346-2.233-7.534-5.024-9.475a12.746 12.746 0 0 0-9.419-1.715 2 2 0 0 0-1.507 2.314c.883 4.72 2.865 8.047 5.894 9.89zm2.774-7.187A7.93 7.93 0 0 1 55.65 37a6.558 6.558 0 0 1-3.679-.967 8.686 8.686 0 0 1-3.472-5.024 7.695 7.695 0 0 1 4.204 1.277zm3.257 11.699a12.746 12.746 0 0 0-9.419-1.715 2 2 0 0 0-1.507 2.314c.883 4.719 2.865 8.046 5.894 9.89A10.827 10.827 0 0 0 56.59 56a11.209 11.209 0 0 0 2.988-.378 2 2 0 0 0 1.407-2.163c-.543-4.347-2.233-7.534-5.024-9.475zm-2.989 7.05A8.686 8.686 0 0 1 49.5 46.01a7.695 7.695 0 0 1 4.204 1.277A7.93 7.93 0 0 1 56.65 52a6.715 6.715 0 0 1-3.679-.966zM69.423 40.62a11.209 11.209 0 0 0 2.988.378 10.828 10.828 0 0 0 5.66-1.526c3.03-1.844 5.012-5.172 5.895-9.891a2 2 0 0 0-1.507-2.314 12.74 12.74 0 0 0-9.419 1.715c-2.79 1.94-4.481 5.129-5.024 9.475a2 2 0 0 0 1.407 2.163zm5.874-8.335a7.695 7.695 0 0 1 4.204-1.277 8.686 8.686 0 0 1-3.472 5.024A7.243 7.243 0 0 1 72.35 37a7.929 7.929 0 0 1 2.947-4.715zM72.04 43.984c-2.791 1.94-4.481 5.128-5.024 9.475a2 2 0 0 0 1.407 2.163 11.209 11.209 0 0 0 2.988.378 10.828 10.828 0 0 0 5.66-1.527c3.03-1.844 5.012-5.171 5.895-9.89a2 2 0 0 0-1.507-2.314 12.745 12.745 0 0 0-9.419 1.715zm2.989 7.05A7.022 7.022 0 0 1 71.35 52a7.929 7.929 0 0 1 2.947-4.714 7.695 7.695 0 0 1 4.204-1.278 8.686 8.686 0 0 1-3.472 5.025z"
      fill="currentColor"
    ></path>
    <path
      d="M42.82 88.009a40.076 40.076 0 0 1 2.215-4H34.264l2.375-4.001h11.14l.12-.164c.961-1.294 1.996-2.538 2.996-3.741l.078-.096h-11.96l2.376-4h10.487a11.9 11.9 0 0 0-.52-1.301l-.145-.185.085.072-.128-.2a12.087 12.087 0 0 1-1.249-2.387h-6.155l2.375-4h3.323a7.055 7.055 0 0 1 2.038-4H22V32.86c3.453-4.092 7.273-12.936-.698-20.327a2.002 2.002 0 0 0-2.655-.058 14.403 14.403 0 0 0-4.613 9.239c-.27 3.682 1.078 7.339 3.966 10.884v27.407H2a2 2 0 0 0 0 4h22.198l-2.75 4.001H2a2 2 0 0 0 0 4h16.698l-2.75 4.001H2a2 2 0 0 0 0 4h11.198l-2.75 4.001H2a2 2 0 0 0 0 4h5.698l-2.75 4.001H2a2 2 0 0 0 0 4h38.306a26.74 26.74 0 0 1 .93-4H29.514l2.375-4Zm-24.8-65.96a9.854 9.854 0 0 1 1.953-5.085c3.579 4.546 1.712 9.19.099 11.75a10.633 10.633 0 0 1-2.052-6.664Zm11.032 41.957h12.434l-2.375 4h-12.81Zm-5.5 8h13.184l-2.375 4.001h-13.56Zm-5.5 8.002h13.934l-2.375 4h-14.31Zm6.81 12.001H9.801l2.75-4h14.684Z"
      fill="currentColor"
    ></path>
    <path
      d="M74.03 78.66c-.982-1.179-1.99-2.392-2.881-3.6a28.472 28.472 0 0 1 1.957-6.507c.095-.21.293-.544.502-.898.844-1.426 2-3.379 1.408-5.361a3.462 3.462 0 0 0-4.006-2.231 6.507 6.507 0 0 0-3.43 2.278 10.913 10.913 0 0 1-1.003.974l-.085-.137a4.584 4.584 0 0 0-1.45-1.615c-1.572-.967-3.129-.434-4.629 1.585-.112.15-.215.297-.316.408a2.193 2.193 0 0 1-.168.163c-.177-.108-.387-.269-.606-.437a6.79 6.79 0 0 0-1.99-1.163 3.007 3.007 0 0 0-2.633.394 3.12 3.12 0 0 0-1.318 2.48 5.518 5.518 0 0 0 1.14 3.22l.214.336c.013.02 1.17 1.896 2.06 6.582-.876 1.183-1.864 2.372-2.825 3.529-.966 1.162-1.965 2.363-2.86 3.57-3.777 5.081-7.57 11.322-7.065 19.085.61 9.416 9.34 14.172 17.264 14.611a49.002 49.002 0 0 0 5.453-.004c7.852-.435 16.58-5.19 17.19-14.607.505-7.766-3.287-14.006-7.063-19.085-.896-1.206-1.895-2.407-2.86-3.57ZM63.036 66.269a7.19 7.19 0 0 0 .387-.47 3.472 3.472 0 0 0 1.852 1.435c2.448.74 4.088-.961 5.178-2.109-.11.191-.211.363-.288.493a13.484 13.484 0 0 0-.707 1.294 30.577 30.577 0 0 0-1.722 5.096h-7.534a26.275 26.275 0 0 0-1.482-4.447 3.87 3.87 0 0 0 4.316-1.292Zm16.925 34.787c-.455 7.023-7.068 10.52-13.421 10.872a45.748 45.748 0 0 1-5.083 0c-6.352-.351-12.965-3.849-13.42-10.872-.42-6.453 2.771-11.714 6.283-16.438.83-1.12 1.751-2.227 2.726-3.4 1.192-1.435 2.426-2.92 3.504-4.452l.475-.675-.014-.083s5.923 0 5.92.023l.464.664c1.092 1.56 2.346 3.068 3.558 4.525.974 1.172 1.895 2.28 2.726 3.398 3.51 4.723 6.701 9.982 6.282 16.438Z"
      fill="currentColor"
    ></path>
    <path
      d="M126 64.006a2 2 0 0 0 0-4h-16V32.86c3.453-4.092 7.273-12.936-.698-20.327a2.002 2.002 0 0 0-2.655-.058 14.403 14.403 0 0 0-4.613 9.239c-.27 3.682 1.078 7.339 3.966 10.884v27.407H78.389a7.008 7.008 0 0 1 .459 1.14 7.916 7.916 0 0 1 .304 2.86h2.71l2.374 4.001h-6.254c-.324.655-.66 1.226-.932 1.686-.12.206-.238.394-.324.563a19.456 19.456 0 0 0-.681 1.752H86.61l2.375 4h-11.96l.079.096c1 1.203 2.034 2.446 2.996 3.74l.12.165h11.14l2.375 4h-10.77a40.06 40.06 0 0 1 2.214 4H96.11l2.375 4.001H86.764a26.75 26.75 0 0 1 .93 4H126a2 2 0 0 0 0-4h-2.948l-2.75-4H126a2 2 0 0 0 0-4h-8.448l-2.75-4.001H126a2 2 0 0 0 0-4h-13.948l-2.75-4.001H126a2 2 0 0 0 0-4h-19.448l-2.75-4.001zM106.02 22.05a9.854 9.854 0 0 1 1.953-5.086c3.579 4.546 1.712 9.19.099 11.75a10.633 10.633 0 0 1-2.052-6.664zm12.178 69.96h-15.06l-2.374-4.001h14.684zm-5.5-8.002h-14.31l-2.374-4h13.934zm-5.5-8h-13.56l-2.374-4.001h13.184zm-5.5-8.002h-12.81l-2.374-4h12.434zM62 57.278a6.819 6.819 0 0 1 4 .323V32.86c3.453-4.093 7.273-12.937-.698-20.328a2.002 2.002 0 0 0-2.655-.058 14.403 14.403 0 0 0-4.613 9.239c-.27 3.682 1.078 7.339 3.966 10.884zm.02-35.228a9.854 9.854 0 0 1 1.953-5.086c3.579 4.546 1.712 9.19.099 11.75a10.633 10.633 0 0 1-2.052-6.664zm2.675 71.516c-1.305-.404-2.123-.684-2.472-1.31a1.627 1.627 0 0 1-.042-1.563 2.424 2.424 0 0 1 2.493-.676 2.35 2.35 0 0 1 1.142.681 2 2 0 0 0 2.87-2.787 6.425 6.425 0 0 0-2.749-1.678v-1.225a2 2 0 1 0-4 0v1.22a5.348 5.348 0 0 0-3.183 2.4 5.631 5.631 0 0 0-.024 5.577c1.144 2.055 3.16 2.68 4.781 3.183 1.712.53 2.241.789 2.445 1.48a1.232 1.232 0 0 1-.77 1.381 2.869 2.869 0 0 1-3.283-.887 2 2 0 1 0-3.081 2.552 7.037 7.037 0 0 0 3.116 2.152v.945a2 2 0 1 0 4 0v-.8a6.11 6.11 0 0 0 .932-.332 5.184 5.184 0 0 0 2.923-6.14c-.842-2.855-3.302-3.616-5.098-4.173z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'today_withdrawal_amount'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
  >
    <path
      d="M90.61 306.85A16.07 16.07 0 0 0 104 293.6C116.09 220.17 169.63 176 232 176c57.93 0 96.62 37.75 112.2 77.74a15.84 15.84 0 0 0 12.2 9.87c50 8.15 91.6 41.54 91.6 99.59c0 59.4-48.6 100.8-108 100.8H106c-49.5 0-90-24.7-90-79.2c0-48.47 38.67-72.22 74.61-77.95z"
      fill="none"
      stroke="currentColor"
      stroke-linejoin="round"
      stroke-width="32"
    ></path>
    <path
      d="M384.8 271.4a80 80 0 1 0-123.55-92"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
    ></path>
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
      d="M464 208h32"
    ></path>
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
      d="M336 48v32"
    ></path>
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
      d="M222.86 94.86l22.63 22.63"
    ></path>
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
      d="M449.14 94.86l-22.63 22.63"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'total_deposit_amount'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <g fill="none">
      <path
        d="M13 6.26a1 1 0 1 1-2-.001a1 1 0 0 1 2 0zm.032-3.924a1.751 1.751 0 0 0-2.064 0L3.547 7.75c-.978.712-.473 2.258.736 2.258H4.5v5.796c-.89.455-1.5 1.38-1.5 2.448v1.5c0 .413.336.749.75.749H11v-1.499H4.5v-.75c0-.69.56-1.249 1.25-1.249H11V16.5c0-.354.074-.691.207-.997H9.5v-5.496h1.75v5.402a2.507 2.507 0 0 1 1.5-1.295v-4.107h1.75v1.543c.375-.192.8-.3 1.25-.3H16v-1.243h2v1.243h1.25c.084 0 .168.004.25.011v-1.254h.217c1.21 0 1.713-1.546.736-2.258l-7.421-5.413zm-1.18 1.211a.25.25 0 0 1 .295 0l6.803 4.96H5.05l6.803-4.96zM6 15.503v-5.496h2v5.496H6zM14 15h-.5a1.5 1.5 0 0 0-1.5 1.5V18h2.5v-.25a.75.75 0 0 1 1.5 0V18h3v-.25a.75.75 0 0 1 1.5 0V18H23v-1.5a1.5 1.5 0 0 0-1.5-1.5H21v-1a1.75 1.75 0 0 0-1.75-1.75h-3.5A1.75 1.75 0 0 0 14 14v1zm1.5-1a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25v1h-4v-1zm-2 9a1.5 1.5 0 0 1-1.5-1.5v-2h2.5v.75a.75.75 0 0 0 1.5 0v-.75h3v.75a.75.75 0 0 0 1.5 0v-.75H23v2a1.5 1.5 0 0 1-1.5 1.5h-8z"
        fill="currentColor"
      ></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'total_deposit_rejected'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32"
  >
    <path
      d="M9 10.555L10.555 9L23 21.444L21.444 23z"
      fill="currentColor"
    ></path>
    <path
      d="M16 2A13.914 13.914 0 0 0 2 16a13.914 13.914 0 0 0 14 14a13.914 13.914 0 0 0 14-14A13.914 13.914 0 0 0 16 2zm0 26a12 12 0 1 1 12-12a12.035 12.035 0 0 1-12 12z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'total_deposit_pending'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 16 16"
  >
    <g fill="none">
      <path
        d="M14 8a6 6 0 1 0-5.746 5.995A4.472 4.472 0 0 1 8.027 13H8a5 5 0 1 1 5-5v.027c.345.039.678.116.995.227C13.998 8.17 14 8.085 14 8zm-5.415 2.28a.749.749 0 0 0-1.335.47a.75.75 0 0 0 .863.742c.099-.431.26-.838.472-1.212zm-.093-5.37A.5.5 0 0 0 7.5 5v3.5l.008.09A.5.5 0 0 0 8.5 8.5V5l-.008-.09zm.559 7.223a2 2 0 0 0 1.407-2.437l-.009-.032c.246-.179.517-.326.806-.436a2.001 2.001 0 0 0 2.557.026c.305.124.588.288.842.487a2.001 2.001 0 0 0 1.302 2.201a3.523 3.523 0 0 1 .026.916l-.033.009a2 2 0 0 0-1.407 2.437l.009.032a3.496 3.496 0 0 1-.806.436a2.001 2.001 0 0 0-2.557-.026a3.5 3.5 0 0 1-.843-.488a2.001 2.001 0 0 0-1.3-2.2a3.524 3.524 0 0 1-.027-.916l.033-.009zm4.199.367a.75.75 0 1 0-1.5 0a.75.75 0 0 0 1.5 0z"
        fill="currentColor"
      ></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'total_deposit_charge'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 1024 1024"
  >
    <path
      d="M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3c2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4l-186.8-186.8l59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7c35.3 0 68.4 13.7 93.4 38.7c24.9 24.9 38.7 58.1 38.7 93.4c0 35.3-13.8 68.4-38.7 93.4zm-190.2 105a8.03 8.03 0 0 0-11.3 0L501 613.3L410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 69-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3c51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 0 1-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7a131.32 131.32 0 0 1-38.7-93.4c0-35.3 13.7-68.4 38.7-93.4l59.4-59.4l186.8 186.8l-59.4 59.4z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'total_withdraw_amount'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <g fill="none">
      <path
        d="M8 2H5a3 3 0 0 0-3 3v3h2.708A2.5 2.5 0 0 1 8 4.708V2zM2 9.5V14a3 3 0 0 0 3 3h3v-6.44l-1.72 1.72a.75.75 0 0 1-1.06-1.06L6.94 9.5H2zM9.5 17H11v-.5a2.5 2.5 0 0 1 2.5-2.5h8c.171 0 .338.017.5.05V9.5H10.56l1.72 1.72a.75.75 0 1 1-1.06 1.06L9.5 10.56V17zM22 8h-9.208A2.5 2.5 0 0 0 9.5 4.708V2H19a3 3 0 0 1 3 3v3zM10.5 8h-1V7a1 1 0 1 1 1 1zM8 8H7a1 1 0 1 1 1-1.008V8zm4 8.5a1.5 1.5 0 0 1 1.5-1.5h8a1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1-1.5 1.5h-8a1.5 1.5 0 0 1-1.5-1.5v-4zm10 .5a1 1 0 0 1-1-1h-1a2 2 0 0 0 2 2v-1zm0 2a2 2 0 0 0-2 2h1a1 1 0 0 1 1-1v-1zm-8-3a1 1 0 0 1-1 1v1a2 2 0 0 0 2-2h-1zm1 5a2 2 0 0 0-2-2v1a1 1 0 0 1 1 1h1zm4.25-2.5a1.75 1.75 0 1 0-3.5 0a1.75 1.75 0 0 0 3.5 0z"
        fill="currentColor"
      ></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'total_withdraw_pending'"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 24 24"
  >
    <path
      d="M6.5 12a5.5 5.5 0 1 1 0 11a5.5 5.5 0 0 1 0-11zm0 7.88a.625.625 0 1 0 0 1.249a.625.625 0 0 0 0-1.249zM17.75 3A3.25 3.25 0 0 1 21 6.25v11.5A3.25 3.25 0 0 1 17.75 21l-5.773.001A6.47 6.47 0 0 0 13 17.5c0-1.515-.519-2.91-1.39-4.013l.07.01l.07.003h4.498l.102-.007a.75.75 0 0 0 0-1.486L16.248 12H12.5V6.75l-.007-.102a.75.75 0 0 0-1.486 0L11 6.75v6l.005.064A6.478 6.478 0 0 0 6.5 11a6.47 6.47 0 0 0-3.501 1.023L3 6.25A3.25 3.25 0 0 1 6.25 3h11.5zM6.5 14.003c-1.048 0-1.864.817-1.853 1.954a.5.5 0 1 0 1-.01c-.006-.578.36-.944.853-.944c.472 0 .853.392.853.95c0 .224-.075.39-.317.677l-.1.113l-.265.29c-.484.542-.671.892-.671 1.468a.5.5 0 1 0 1 0c0-.233.076-.403.324-.695l.1-.115l.266-.29c.478-.535.663-.882.663-1.448c0-1.104-.822-1.95-1.853-1.95z"
      fill="currentColor"
      fill-rule="nonzero"
    />
  </svg>

  <svg
    v-else-if="name === 'total_withdraw_rejected'"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 24 24"
  >
    <g fill="currentColor">
      <path
        d="M10.03 8.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.97 1.97a.75.75 0 1 0 1.06 1.06L12 13.06l1.97 1.97a.75.75 0 0 0 1.06-1.06L13.06 12l1.97-1.97a.75.75 0 1 0-1.06-1.06L12 10.94l-1.97-1.97Z"
      />
      <path
        fill-rule="evenodd"
        d="M12 1.25c-.938 0-1.833.307-3.277.801l-.727.25c-1.481.506-2.625.898-3.443 1.23c-.412.167-.767.33-1.052.495c-.275.16-.55.359-.737.626c-.185.263-.281.587-.341.9c-.063.324-.1.713-.125 1.16c-.048.886-.048 2.102-.048 3.678v1.601c0 6.101 4.608 9.026 7.348 10.224l.027.011c.34.149.66.288 1.027.382c.387.1.799.142 1.348.142c.55 0 .96-.042 1.348-.142c.367-.094.687-.233 1.026-.382l.028-.011c2.74-1.198 7.348-4.123 7.348-10.224V10.39c0-1.576 0-2.792-.048-3.679a8.85 8.85 0 0 0-.125-1.16c-.06-.312-.156-.636-.34-.9c-.188-.266-.463-.465-.738-.625a8.554 8.554 0 0 0-1.052-.495c-.818-.332-1.962-.724-3.443-1.23l-.727-.25c-1.444-.494-2.34-.801-3.277-.801ZM9.08 3.514c1.615-.552 2.262-.764 2.92-.764c.658 0 1.305.212 2.92.764l.572.196c1.513.518 2.616.896 3.39 1.21c.387.158.667.29.864.404c.097.056.164.102.208.139c.038.03.053.048.055.05a.408.408 0 0 1 .032.074c.02.056.042.136.063.248a7.4 7.4 0 0 1 .1.958c.046.841.046 2.015.046 3.624v1.574c0 5.175-3.87 7.723-6.449 8.849c-.371.162-.586.254-.825.315c-.228.059-.506.095-.976.095s-.748-.036-.976-.095c-.24-.06-.454-.153-.825-.315c-2.58-1.127-6.449-3.674-6.449-8.849v-1.574c0-1.609 0-2.783.046-3.624a7.4 7.4 0 0 1 .1-.958c.021-.112.043-.192.063-.248c.018-.05.03-.07.032-.074a.386.386 0 0 1 .055-.05a1.57 1.57 0 0 1 .208-.14c.197-.114.477-.245.864-.402c.774-.315 1.877-.693 3.39-1.21l.573-.197Z"
        clip-rule="evenodd"
      />
    </g>
  </svg>

  <svg
    v-else-if="name === 'total_withdraw_charge'"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M12 12a3 3 0 1 0 3 3a3 3 0 0 0-3-3Zm0 4a1 1 0 1 1 1-1a1 1 0 0 1-1 1Zm-.71-6.29a1 1 0 0 0 .33.21a.94.94 0 0 0 .76 0a1 1 0 0 0 .33-.21L15 7.46A1 1 0 1 0 13.54 6l-.54.59V3a1 1 0 0 0-2 0v3.59L10.46 6A1 1 0 0 0 9 7.46ZM19 15a1 1 0 1 0-1 1a1 1 0 0 0 1-1Zm1-7h-3a1 1 0 0 0 0 2h3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h3a1 1 0 0 0 0-2H4a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3ZM5 15a1 1 0 1 0 1-1a1 1 0 0 0-1 1Z"
    />
  </svg>

  <svg
    v-else-if="name === 'investments'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 640 512"
  >
    <path
      d="M608 32H32C14.33 32 0 46.33 0 64v384c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM176 327.88V344c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35c-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73c3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19c0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39c0-24.52 19.05-44.44 42.67-45.07V152c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35c3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73c-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19c0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39c0 24.53-19.05 44.44-42.67 45.07zM416 312c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm160 0c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h272c4.42 0 8 3.58 8 8v16z"
      fill="currentColor"
    ></path>
  </svg>

  <svg
    v-else-if="name === 'interests'"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M12 2.25a.75.75 0 0 1 .75.75v16.19l6.22-6.22a.75.75 0 1 1 1.06 1.06l-7.5 7.5a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 1 1 1.06-1.06l6.22 6.22V3a.75.75 0 0 1 .75-.75Z"
      clip-rule="evenodd"
    />
  </svg>
  <svg
    v-else-if="name === 'invest_comp'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 20 20"
  >
    <g fill="none">
      <path
        d="M9 6a2 2 0 1 0 0 4a2 2 0 0 0 0-4zM8 8a1 1 0 1 1 2 0a1 1 0 0 1-2 0zM2 4.5A1.5 1.5 0 0 1 3.5 3h11A1.5 1.5 0 0 1 16 4.5V8h-1V7h-1a2 2 0 0 1-2-2V4H6v1a2 2 0 0 1-2 2H3v2h1a2 2 0 0 1 2 2v1h5v1H3.5A1.5 1.5 0 0 1 2 11.5v-7zM3.5 4a.5.5 0 0 0-.5.5V6h1a1 1 0 0 0 1-1V4H3.5zm11 0H13v1a1 1 0 0 0 1 1h1V4.5a.5.5 0 0 0-.5-.5zm-11 8H5v-1a1 1 0 0 0-1-1H3v1.5a.5.5 0 0 0 .5.5zM17 8V5.085A1.5 1.5 0 0 1 18 6.5V8h-1zm-6 6v1H5.5a1.5 1.5 0 0 1-1.415-1H11zm2.5-5a1.5 1.5 0 0 0-1.5 1.5v7a1.5 1.5 0 0 0 1.5 1.5h4a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 17.5 9h-4zm0 4h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm3 0h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm-3 2h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm3 0h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm-3 2h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm3 0h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zM13 10.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1z"
        fill="currentColor"
      ></path>
    </g>
  </svg>

  <svg
    v-else-if="name === 'rank'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="32"
    viewBox="0 0 384 512"
  >
    <path
      fill="currentColor"
      d="M173.8 5.5c11-7.3 25.4-7.3 36.4 0L228 17.2c6 3.9 13 5.8 20.1 5.4l21.3-1.3c13.2-.8 25.6 6.4 31.5 18.2l9.6 19.1c3.2 6.4 8.4 11.5 14.7 14.7l19.3 9.7c11.8 5.9 19 18.3 18.2 31.5l-1.3 21.3c-.4 7.1 1.5 14.2 5.4 20.1l11.8 17.8c7.3 11 7.3 25.4 0 36.4L366.8 228c-3.9 6-5.8 13-5.4 20.1l1.3 21.3c.8 13.2-6.4 25.6-18.2 31.5l-19.1 9.6c-6.4 3.2-11.5 8.4-14.7 14.7l-9.7 19.3c-5.9 11.8-18.3 19-31.5 18.2l-21.3-1.3c-7.1-.4-14.2 1.5-20.1 5.4l-17.8 11.8c-11 7.3-25.4 7.3-36.4 0L156 366.8c-6-3.9-13-5.8-20.1-5.4l-21.3 1.3c-13.2.8-25.6-6.4-31.5-18.2l-9.6-19.1c-3.2-6.4-8.4-11.5-14.7-14.7L39.5 301c-11.8-5.9-19-18.3-18.2-31.5l1.3-21.3c.4-7.1-1.5-14.2-5.4-20.1L5.5 210.2c-7.3-11-7.3-25.4 0-36.4L17.2 156c3.9-6 5.8-13 5.4-20.1l-1.3-21.3c-.8-13.2 6.4-25.6 18.2-31.5l19.1-9.6C65 70.2 70.2 65 73.4 58.6L83 39.5c5.9-11.8 18.3-19 31.5-18.2l21.3 1.3c7.1.4 14.2-1.5 20.1-5.4l17.9-11.7zM272 192a80 80 0 1 0-160 0a80 80 0 1 0 160 0zM1.3 441.8l43.1-102.5c.2.1.3.2.4.4l9.6 19.1c11.7 23.2 36 37.3 62 35.8l21.3-1.3c.2 0 .5 0 .7.2l17.8 11.8c5.1 3.3 10.5 5.9 16.1 7.7l-37.6 89.3c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2l-32.2-49.3l-56.1 8.3c-5.7.8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4L211.7 413c5.6-1.8 11-4.3 16.1-7.7l17.8-11.8c.2-.1.4-.2.7-.2l21.3 1.3c26 1.5 50.3-12.6 62-35.8l9.6-19.1c.1-.2.2-.3.4-.4l43.2 102.5c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3l-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z"
    />
  </svg>
</template>

<script>
  export default {
    name: 'Icon',
    props: {
      name: String,
    },
  };
</script>
